var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTractorTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4025.51 1242.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d3d3d;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74{stroke-width:0px;}.cls-1,.cls-14,.cls-18,.cls-19,.cls-21,.cls-24,.cls-75,.cls-31,.cls-42,.cls-47,.cls-49,.cls-56,.cls-64,.cls-76,.cls-77,.cls-72,.cls-73{mix-blend-mode:multiply;}.cls-2{fill:#9be9e3;}.cls-2,.cls-4,.cls-5,.cls-8,.cls-15,.cls-26,.cls-32,.cls-37,.cls-38,.cls-43,.cls-48,.cls-78,.cls-51,.cls-61,.cls-63,.cls-69{mix-blend-mode:screen;}.cls-2,.cls-28{opacity:.3;}.cls-3{fill:#2c2d2b;}.cls-4{fill:#ededed;}.cls-5,.cls-14,.cls-26,.cls-37,.cls-38,.cls-43,.cls-51,.cls-69{opacity:.5;}.cls-5,.cls-63{fill:#949494;}.cls-6,.cls-47,.cls-48{fill:#ff9921;}.cls-7{fill:#5c5c5c;}.cls-8,.cls-58{fill:#303030;}.cls-9{fill:#666;}.cls-10{fill:#727271;}.cls-11{fill:#427724;}.cls-12,.cls-14{fill:#914a17;}.cls-13{fill:none;}.cls-15{fill:#ffd4a8;}.cls-16{fill:#b9661c;}.cls-17{fill:#4c2f07;}.cls-18,.cls-60{fill:#989898;}.cls-19,.cls-25,.cls-31,.cls-32{fill:#525252;}.cls-20,.cls-56{fill:#292929;}.cls-21{fill:#2e2d2c;}.cls-22,.cls-43,.cls-72{fill:#1d1d1b;}.cls-23,.cls-42,.cls-73{fill:#818080;}.cls-24{fill:url(#linear-gradient);}.cls-26,.cls-67{fill:#fff;}.cls-27{fill:#bdbdbd;}.cls-28{fill:#00a8e3;}.cls-29{fill:#e3e3e3;}.cls-30{fill:#be3324;}.cls-31,.cls-42,.cls-47,.cls-76{opacity:.4;}.cls-33{fill:#e87221;}.cls-34{fill:#ffaf21;}.cls-35{fill:#ffde6b;}.cls-36{fill:#686867;}.cls-37{fill:url(#radial-gradient-3);}.cls-38{fill:url(#radial-gradient-2);}.cls-39{fill:#000;}.cls-40{fill:#121212;}.cls-41{fill:#23211f;}.cls-44{fill:#aeaeae;}.cls-45{fill:#4b4b4b;}.cls-46{fill:#2b2b2b;}.cls-49,.cls-50{fill:#2d2e2d;}.cls-51{fill:url(#radial-gradient);}.cls-52{fill:#0f0f0f;}.cls-53{fill:#bbbaba;}.cls-54{fill:#8f8f8f;}.cls-55{fill:#6e460d;}.cls-57{fill:#744705;}.cls-59{fill:#262626;}.cls-61,.cls-70{fill:#1c1c1c;}.cls-62{fill:#ed3a0f;}.cls-79{isolation:isolate;}.cls-64{fill:#696969;}.cls-65{fill:#f08b00;}.cls-66{fill:#ca7123;}.cls-68{fill:#525252;}.cls-69{fill:#636363;}.cls-71{fill:#fcbf29;}.cls-77{opacity:.8;}.cls-74{fill:#363432;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2987.57,
    y1: 1018.55,
    x2: 2987.57,
    y2: 822.23,
    gradientTransform: "translate(4180.03) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6b8b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 3919.38,
    cy: 1056.53,
    fx: 3919.38,
    fy: 1056.53,
    r: 206.58,
    gradientTransform: "translate(4180.03) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1e211d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#232521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#313330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#494a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#595956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#686865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#91908f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#b3b2b1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 3389.65,
    fx: 3389.65,
    r: 206.58,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 2372.71,
    fx: 2372.71,
    r: 206.52,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "3214.46 571.35 3154.19 636.32 3223.06 636.32 3214.46 571.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "3142.48 346.2 3150.85 385.66 3146.62 391.77 3137.49 352.68 3142.48 346.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "3093.5 411.29 3133.6 406.22 3138.04 400.32 3098.08 404.42 3093.5 411.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "3226.97 622.75 2881.71 622.75 2881.71 673.11 3199.75 673.11 3226.97 622.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "3226.97 647.14 2881.71 647.14 2881.71 673.11 3199.75 673.11 3226.97 647.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "3194.59 418.37 3128.76 369.23 3113.74 388 3171.83 447.32 3194.59 418.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M3180.64,436.12l-8.81,11.2-58.09-59.32,8.33-10.38c11.54,11.26,50.53,50.29,58.58,58.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M3118.6,392.96l-4.86-4.97,15.03-18.77,3.91,2.97c-4.5,7.08-9.19,13.94-14.07,20.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M3166.95,397.81l27.64,20.55-22.76,28.95-24.66-25.21c6.72-7.97,13.4-16.12,19.78-24.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "3201.73 389.87 3186.16 381.58 3142.48 437.28 3152.73 455.25 3201.73 389.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M3086.04,400.21c-5.73,7.53-7.1,16.16-3.06,19.1h0c4.1,3.05,11.96-.68,17.6-8.25l44.91-60.32c5.73-7.6,6.97-16.16,2.94-19.17h0c-4.01-3.04-11.83.68-17.48,8.21l-44.91,60.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3254.21,424.81l-9.95-46.22-44.29,2.99-51.25,66.31s-4.4,3.81,0,14.42c4.38,10.64,68.6,181,68.6,181l64.98-35-28.08-183.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3254.21,424.81l-9.95-46.22-29.8,1.99,44.55,199.66s-53.7,30.87-52.17,35.26c4.12,10.66,10.48,27.82,10.48,27.82l64.98-35-28.08-183.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2843.12,507.89s147.93,11.19,210.69,21.47c0,0,20.58,3.71,26.31,31.83,5.56,28.12,13.97,122.68,13.97,122.68h-175.12l-75.84-175.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2879.47,592.03l-36.35-84.14s147.93,11.19,210.69,21.47c0,0,20.58,3.71,26.31,31.83,1.33,6.99,2.85,18.19,4.46,30.84h-205.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2905.33,522.76s85.71,6.37,140.36,15.26c0,0,17.98,3.2,22.74,27.67,4.99,24.44,10.9,92.08,10.9,92.08h-116.57l-12.51-95.04-43.49-30.91-1.44-9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M3043.24,543.56c-48.16-7.88-120.62-13.69-137.04-14.91l-.87-5.9s85.71,6.37,140.36,15.26c0,0,17.98,3.2,22.74,27.67,4.99,24.44,10.9,92.08,10.9,92.08h-2.94c-1.67-16.59-6.45-66.28-10.44-86.55-4.73-24.34-22.72-27.66-22.72-27.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "3168.56 400.78 3131.43 372.55 3129.78 374.6 3164.58 405.85 3168.56 400.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M3044.45,489.73s47.72,3.11,49.64,21.22c1.88,18.18-16.44,20.82-35.84,19.87l-149.36-17.51s-9.85-1.16-13.61-11.74c-3.7-10.63-21.77-108.14-26.84-156.6,0,0-1.23-27.52,15.6-28.11,16.91-.7,33.05,9.93,39.39,29.33,6.19,19.34,18.15,120.51-1.27,142.91,0,0,10.33-7.8,49.32-5.63,28,1.57,72.97,6.25,72.97,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2884.03,316.87c7.08-.26,13.97,1.44,20.05,4.86-.38,0-.93-.11-1.29-.11-8.26-.26-19.15,4.92-18.93,14.43.17,6.81,2.79,13.02,4.88,19.43,2.92,8.89,5.62,17.85,7.16,27.11,3.02,19.53,3.76,39.08,4.25,58.75.23,9.29-.55,20.86,7.31,27.31,5.71,4.83,15.96,1.25,20.14-3.94,1.73-2.13,3-4.29,4.02-6.55-1.56,13.78-4.4,25.07-9.47,30.94,0,0,5.73-4.39,24.75-5.63,4.02,7.59,5.75,16.27,14.54,20.23,10.71,4.92,25.42,5.19,36.85,7.08,17.41,2.61,34.8,5.01,52.41,7.24,13.74,1.83,27.58,2.48,41.46,3.55-5.18,8.53-19.31,10.02-33.92,9.25l-149.36-17.51s-9.85-1.16-13.61-11.74c-3.7-10.63-21.77-108.14-26.84-156.6,0,0-1.23-27.52,15.6-28.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M2881.71,510.95s19.23-34.29,46.66-34.94c27.49-.58,15.6,41.45,15.6,41.45l-62.26-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2900.28,323.52s14.22,1.36,21.98,32.14c7.8,30.84,9.53,96.19,5.14,104.55,0,0-2.3-105.06-27.11-136.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2913.26,498.37c0,4.54,3.61,8.27,8.22,8.27s8.28-3.73,8.28-8.27-3.7-8.38-8.28-8.38-8.22,3.73-8.22,8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M2917.08,498.37c0,2.46,1.88,4.42,4.4,4.42s4.52-1.95,4.52-4.42-2.03-4.52-4.52-4.52-4.4,2.01-4.4,4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3092.16,514.97s2.64-17.51-45.29-23.5c0,0-78.97-7.77-86.9-6.64,0,0,89.37,8.24,106.55,13.54,17.03,5.22,25.63,16.6,25.63,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3553.33,338.97h32.27V72.53c0-1.8.95-20.22,18.39-24.38,30.58-7.05,68.7-16.86,69.08-16.99l-8.09-31.16c-.32.1-38.1,9.82-68.24,16.84-34.13,8-43.3,39.96-43.41,55.68v266.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M3596.74,16.84c30.13-7.03,67.92-16.75,68.24-16.84l2.18,8.25-70.98,17.07s-32.02,8.69-34.21,54.29v231.52l23.65,5.5v22.33h-32.27V72.53c.11-15.72,9.28-47.68,43.41-55.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "3447.37 352.9 3447.37 305.34 3615.76 326.44 3615.76 377.38 3447.37 352.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "3447.37 373.1 3447.37 325.35 3615.76 346.57 3615.76 397.5 3447.37 373.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "3580.91 64.28 3580.91 311.14 3574.29 311.14 3575.65 87.19 3580.91 64.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3228.36,312.8s510.3,45.75,636.63,98.14c0,0,21.85,9.82,39.35,57.19,17.39,47.4,82.78,313.33,82.78,313.33h-682.36l-76.39-468.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M3800.35,689.3c-70.29-44.63-153.42-77.25-233.13-60.37-85.23,18.34-156.7,84.72-210.16,166.5-15.55,23.67-32.59,46.41-45.35,72.57-2.77,5.77-5.37,11.77-7.65,17.84l-75.7-573.03s19.89,2.23,52.45,6.08l68.93,381.16s62.51-148.83,312.65-125.48c196.36,18.31,283.21,181.48,311.49,250.65,7.95,39.28,13.23,65.68,13.23,65.68h-27.58c-28.04-90.78-90.36-157.98-159.19-201.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M3456.33,367.69l290.17,36.51s97.93,14.75,116.16,47.77c18.13,32.99,36.33,128.69,36.33,128.69l-61.18,1.95s-45.75-72.05-77.6-74.6c-31.91-2.49-291.41-13.96-291.41-13.96,0,0-11.28,3.41-20.46-15.88-9.07-19.39-22.78-86.64-22.78-86.64,0,0,.21-30.2,30.77-23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3461.7,378.59l278.84,34.49s92.47,9.47,112.19,51.64c15.87,34.08,33.07,115.93,33.07,115.93l-47.99,1.95s-45.75-72.05-77.6-74.6c-31.91-2.49-291.41-13.96-291.41-13.96,0,0-11.28,3.41-20.46-15.88-9.07-19.39-22.78-86.64-22.78-86.64,0,0,5.58-19.45,36.14-12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3447.02,476.25c-2.96-4.39-5.73-8.8-8.62-13.19,1.1-1.63,2.09-3.1,3.04-4.75,2.13,6.86,4.04,13,5.94,17.38-.17.18-.36.38-.36.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3879,550.79c-.85-3.43-1.71-7.11-2.64-10.87,1.65,2.48,3.23,5.03,4.86,7.49-.76,1.25-1.54,2.31-2.22,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3458.09,491.18c-.19.39-.57.77-.76,1.13-1.14-1.72-2.3-3.38-3.36-5.12,1.44,1.74,2.79,2.96,4.12,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3753.56,509.99c-.57-.9-1.16-1.72-1.73-2.58,1.16.12,2.22.2,3.28.2-.57.83-1.06,1.64-1.54,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3778.2,420.08c-2.28-.55-4.46-1.13-6.68-1.63.97-1.5,1.9-3,2.87-4.42,1.33,1.89,2.58,4.03,3.8,6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3859.05,480.55c-.61-1.61-1.16-3.18-1.71-4.68.74,1.27,1.59,2.51,2.37,3.76-.17.23-.44.68-.66.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3804.19,428.11c-4.58-1.69-9.19-3.3-13.65-4.71,1.82-2.75,3.55-5.44,5.35-8.18,2.73,4.31,5.45,8.59,8.3,12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3428.48,413.45c.36-.73.93-1.52,1.33-2.17.55,2.12.97,4.3,1.52,6.55-.97-1.36-1.92-2.92-2.85-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3435.73,459.07c-2.68-4.18-5.37-8.36-8.03-12.43,2.6-3.93,5.18-7.81,7.63-11.74,1.52,5.97,3.06,12,4.58,17.75-1.31,2.13-2.77,4.28-4.18,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3687.06,509.01c-1.16-1.66-2.22-3.4-3.28-5.12,2.11.06,4.18.15,6.3.26-.93,1.66-2.11,3.27-3.02,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3730.36,508.57c-.51-.79-1.1-1.6-1.65-2.4,1.14,0,2.09.09,3.04.09-.49.8-.95,1.52-1.4,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3708.55,507.78c-.68-.8-1.23-1.82-1.8-2.73,1.12.08,2.26.08,3.42.12-.59.92-1.16,1.81-1.63,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3633.44,399.78l-2.11-.26c.3-.46.68-.96.97-1.44.38.57.72,1.15,1.14,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3680.93,405.64l-7.86-.95c1.16-1.79,2.43-3.7,3.68-5.54,1.31,2.09,2.77,4.33,4.18,6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3656.63,402.68l-4.16-.56c.55-.98,1.31-2.04,1.9-2.97.74,1.16,1.54,2.42,2.26,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3511.98,384.84l-.68-.13c.13-.2.3-.38.3-.45.19.18.32.35.38.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3433.64,429.46c-2.85,4.4-5.77,8.73-8.5,13.14-2.62-4.1-5.26-8.01-7.75-11.91,2.87-4.38,5.66-8.79,8.39-13.22,2.7,3.96,5.16,7.81,7.86,11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3749.19,479.27c-2.54,3.97-5.18,8.06-7.73,12.02-2.79-4.44-5.64-8.82-8.56-13.21,2.56-4.03,5.2-8.06,7.84-12.02,2.81,4.41,5.54,8.74,8.45,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3497.08,495.33c-5.37-.24-9.95-.44-13.76-.65,2.11-3.38,4.37-6.82,6.59-10.31,2.39,3.64,4.67,7.29,7.16,10.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3475.69,494.44c-4.44-.33-6.89-.39-6.89-.39,0,0-2.89.92-6.89-.74,2.11-3.41,4.4-6.7,6.51-10.16,2.47,3.71,4.78,7.44,7.27,11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3519.92,496.33c-5.64-.23-11.01-.48-15.93-.66,2.64-4.03,5.13-8.05,7.8-12.09,2.71,4.27,5.35,8.54,8.14,12.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3455.41,463.06c-2.68,4.3-5.33,8.51-8.03,12.63-1.9-4.39-3.8-10.52-5.94-17.38,1.94-2.77,3.68-5.65,5.5-8.41,2.73,4.42,5.64,8.8,8.47,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3541.31,496.33c-.25.38-.44.66-.68.95-5.11-.3-10.12-.48-14.98-.71,2.62-4.07,5.26-8.18,7.92-12.21,2.49,3.94,5.16,7.95,7.73,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3444.31,445.89c-1.5,2.27-2.94,4.45-4.4,6.76-1.52-5.75-3.06-11.78-4.58-17.75.29-.48.61-.99.95-1.47,2.62,4.13,5.28,8.24,8.03,12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3730.36,450.05c2.54,3.94,5.09,7.99,7.73,11.97-2.64,4.04-5.2,8-7.73,12.03-2.62-4.04-5.2-8-7.78-12.03,2.58-3.98,5.16-8.03,7.78-11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3687.06,482.59c2.85,4.39,5.71,8.77,8.5,13.27-1.82,2.79-3.55,5.57-5.47,8.29-2.11-.12-4.18-.2-6.3-.26-1.8-2.69-3.53-5.36-5.35-8.03,2.9-4.5,5.73-8.89,8.62-13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3458.09,467.1c2.49,3.94,5.16,8.02,7.71,12.06-2.56,3.99-5.14,8.03-7.71,12.02-1.33-1.04-2.68-2.25-4.12-3.99-1.4-2.35-2.98-4.6-4.5-6.78,2.92-4.4,5.75-8.83,8.62-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3657.05,502.67c-1.44-.12-2.79-.12-4.12-.23.63-1.01,1.25-2.02,2.01-3.09.68,1.07,1.33,2.13,2.11,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3665.27,483.36c2.64,4.09,5.35,8.29,8.01,12.5-1.48,2.4-3.15,4.89-4.75,7.38-2.01-.08-4.04-.2-6.13-.32-1.73-2.61-3.28-5.07-4.92-7.59,2.64-3.97,5.07-8,7.8-11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3643.74,482.11c2.79,4.39,5.66,8.83,8.56,13.22-1.58,2.37-2.98,4.5-4.46,6.82-2.85-.06-5.62-.18-8.35-.36-1.52-2.13-2.92-4.32-4.25-6.46,2.79-4.38,5.64-8.83,8.5-13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3678.37,503.59c-1.63,0-3.17-.12-4.73-.2.8-1.13,1.56-2.38,2.35-3.56.76,1.28,1.52,2.48,2.39,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3554.98,483.15c2.87,4.38,5.75,8.8,8.62,13.19-.38.66-.89,1.25-1.27,1.92-5.03-.2-10.23-.56-14.98-.68-.27-.39-.55-.87-.85-1.25,2.83-4.38,5.6-8.8,8.47-13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3576.62,484.36c2.85,4.56,5.79,9.07,8.77,13.57-.3.48-.57.87-.91,1.34-4.82-.27-9.61-.48-14.2-.62-.57-.8-.97-1.54-1.54-2.31,2.66-4.03,5.16-8.03,7.88-11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3727.74,411.54c-2.85,4.38-5.73,8.83-8.58,13.22-2.7-4.21-5.35-8.28-8.03-12.46.59-.91,1.14-1.8,1.69-2.62l14.75,1.83c.17,0,.17.03.17.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3634.01,501.49c-.87,0-1.82,0-2.79-.06.57-.68.97-1.36,1.35-2.07.57.71.93,1.48,1.44,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3622.24,483.36c2.62,3.97,5.2,8,7.73,11.97-1.2,1.96-2.47,3.88-3.72,5.86-3.91-.18-7.86-.36-11.77-.57-.55-.88-1.1-1.74-1.67-2.69,3.13-4.85,6.3-9.71,9.42-14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3443.95,413.41c-2.58,3.99-5.16,8.03-7.67,11.98-1.67-2.55-3.32-5.02-4.94-7.55-.55-2.25-.97-4.43-1.52-6.55,2.09-3.28,4.18-6.59,6.32-9.85,2.51,3.94,5.16,7.94,7.82,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3641.09,411.64c-2.79,4.28-5.66,8.73-8.52,13.11-2.98-4.58-5.92-9.07-8.81-13.58,2.49-3.93,5.07-7.82,7.57-11.66l2.11.26c2.47,3.84,5.05,7.77,7.65,11.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3643.67,407.55c-1.52-2.37-3.06-4.64-4.61-7.06l8.58,1.09c-1.27,1.93-2.66,3.99-3.97,5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3662.97,412.3c-2.66,4.17-5.35,8.35-8.14,12.46-2.85-4.39-5.73-8.83-8.45-13.11,1.94-3.21,3.97-6.37,6.09-9.52l4.16.56c2.11,3.17,4.23,6.38,6.34,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3621.12,407.19c-2.11-3.24-4.21-6.52-6.36-9.69l11.71,1.47c-1.75,2.74-3.42,5.45-5.35,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3684.35,411.06c-2.75,4.38-5.54,8.83-8.37,13.22-2.71-4.03-5.28-8.01-7.86-11.98,1.71-2.56,3.25-5.05,4.95-7.61l7.86.95c1.12,1.84,2.28,3.63,3.42,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3687.06,407.11c-.21-.25-.4-.55-.4-.68l.74.06c-.15.17-.27.36-.34.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3428.48,405.27c-1.73-8.31-2.92-13.75-2.92-13.75,0,0,.51-1.58,1.75-3.53,2.03,3.05,4.1,6.22,6.23,9.39-1.65,2.69-3.34,5.29-5.07,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3599.72,405.98c-2.49-3.76-5.01-7.6-7.46-11.33l13.55,1.73c-1.97,3.28-3.99,6.41-6.09,9.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3665.54,408.33c-1.06-1.76-2.18-3.36-3.15-4.97l5.81.76c-.85,1.45-1.78,2.74-2.66,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3705.97,412.3c-2.68,3.97-5.18,7.96-7.86,11.98-2.83-4.38-5.68-8.89-8.47-13.22.85-1.32,1.69-2.63,2.56-3.95l11.22,1.32c.85,1.31,1.61,2.54,2.56,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3519.44,396.18c-2.56,3.91-5.16,7.95-7.73,11.94-2.58-4.07-5.24-8.03-7.71-11.94,2.47-3.89,4.92-7.7,7.31-11.46l.68.13c2.51,3.63,4.94,7.45,7.46,11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3478.99,392.18c-2.73-4.18-5.39-8.43-8.09-12.43h0l14.9,1.83c-2.22,3.5-4.46,7.03-6.8,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3501.28,392.18c-2.11-3.3-4.08-6.41-6.13-9.49l11.31,1.37c-1.73,2.71-3.47,5.33-5.18,8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3436.13,393.5c-2.01-3.13-4.04-6.18-5.92-9.17,2.66-2.64,6.64-5.26,12.76-6.48.59.81,1.18,1.57,1.75,2.47-2.87,4.38-5.77,8.71-8.6,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3564.34,394.11c-3.06,4.75-6.19,9.62-9.36,14.49-2.68-4.17-5.45-8.38-8.01-12.42,1.37-2.21,2.77-4.41,4.21-6.59l11.24,1.47c.68,1.02,1.37,1.98,1.92,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3586.7,394.11c-2.85,4.28-5.75,8.7-8.58,13.08-2.87-4.38-5.75-8.8-8.41-13.08.38-.68.76-1.36,1.14-2.03l15.85,1.89v.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3544.29,392.18c-.76-1.33-1.5-2.49-2.41-3.71l4.37.56c-.63,1.01-1.29,2.05-1.97,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3541.6,396.18c-2.79,4.31-5.54,8.7-8.41,13.1-2.83-4.41-5.75-8.79-8.6-13.1,2.01-3.06,4.04-6.13,5.92-9.04l5.77.67c1.67,2.73,3.63,5.53,5.33,8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3599.72,440.34c-2.89-4.44-5.73-8.82-8.62-13.11,2.89-4.49,5.73-8.86,8.62-13.2,2.73,4.33,5.62,8.71,8.5,13.2-2.75,4.29-5.62,8.67-8.5,13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3599.17,484.72c2.73,4.39,5.62,8.83,8.37,13.21-.38.8-.91,1.55-1.44,2.28-4.86-.15-9.66-.46-14.58-.61-.23-.51-.63-1.07-.99-1.67,2.87-4.37,5.73-8.82,8.64-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3873.36,567.56c3,4.47,5.75,8.89,8.54,13.15l-16.55.77c-.17-.18-.36-.48-.46-.66,2.75-4.38,5.66-8.8,8.47-13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3851.97,534.14c2.58,4.12,5.13,8.18,7.73,12.02-2.85,4.51-5.73,8.95-8.52,13.33-2.58-3.91-5.16-7.91-7.82-12.09,2.87-4.38,5.73-8.71,8.6-13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3838.24,547.41c-3,4.62-5.94,9.25-8.83,13.69-2.83-4.33-5.64-8.72-8.58-13.15,2.94-4.63,5.94-9.21,8.85-13.81,2.94,4.56,5.64,8.89,8.56,13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3827.52,496.33c-2.87,4.42-5.64,8.83-8.52,13.27-2.77-4.44-5.62-8.77-8.5-13.27,2.87-4.38,5.73-8.8,8.58-13.19,2.79,4.38,5.62,8.8,8.43,13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3848.51,563.47c-2.94,4.71-5.87,9.3-8.75,13.68-2.49-3.79-5.18-7.82-7.73-12.02,2.96-4.5,5.79-9.07,8.75-13.66,2.68,4.12,5.26,8.09,7.73,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3481.61,396.18c2.87-4.41,5.73-8.82,8.58-13.15,2.7,4.3,5.56,8.69,8.49,13.15-2.75,4.31-5.64,8.7-8.49,13.1-2.85-4.41-5.71-8.79-8.58-13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3800.16,480.3c2.92-4.44,5.64-8.82,8.54-13.21,2.6,3.94,5.13,8.02,7.73,12.06-2.9,4.32-5.75,8.77-8.5,13.16-2.58-4-5.2-8-7.78-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3701.41,504.69c-2.11-.06-4.16-.12-6.25-.24,1.08-1.53,2.05-3.02,2.96-4.62,1.18,1.66,2.13,3.32,3.3,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3838.24,512.84c-2.92,4.53-5.75,8.92-8.56,13.32-2.64-4.17-5.35-8.38-8.07-12.52,2.83-4.38,5.71-8.83,8.62-13.22,2.64,4.15,5.3,8.29,8.01,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3880.46,556.69c2.28,9.68,3.89,17.24,4.78,21.12-3.06-4.68-6-9.36-9.19-14.34,1.48-2.17,2.87-4.45,4.42-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3533.57,441.79c-2.77-4.23-5.56-8.36-8.14-12.43,2.58-4.08,5.2-8.03,7.76-11.96,2.68,4.07,5.33,8.23,8.05,12.44-2.51,4.02-5.18,7.9-7.67,11.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3511.7,442.53c-2.87-4.38-5.64-8.89-8.5-13.17,2.85-4.43,5.62-8.81,8.5-13.2,2.79,4.31,5.66,8.64,8.5,13.2-2.83,4.38-5.64,8.78-8.5,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3514.28,412.19c2.6-4.08,5.16-8.07,7.71-11.98,2.81,4.28,5.68,8.7,8.52,13.09-2.49,3.98-5.16,8.03-7.61,11.98-2.98-4.43-5.77-8.81-8.62-13.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3492.79,413.41c2.9-4.5,5.71-8.92,8.5-13.2,2.58,3.91,5.18,7.8,7.84,11.98-2.89,4.28-5.73,8.71-8.62,13.09-2.56-4.06-5.11-8-7.71-11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3576.47,441.79c-2.58-4.05-5.16-8.04-7.73-11.95,3.28-4.9,6.28-9.76,9.38-14.62,2.66,3.88,5.16,7.91,7.84,12.01-3.17,4.83-6.3,9.7-9.49,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3557.66,412.63c3.06-4.88,6.28-9.72,9.36-14.55,2.77,4.31,5.62,8.59,8.62,13.1-3.28,4.85-6.34,9.72-9.55,14.66-2.87-4.5-5.66-8.89-8.43-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3580.78,411.18c2.87-4.37,5.77-8.79,8.52-13.1,2.58,3.85,5.07,7.87,7.71,11.95-2.85,4.28-5.62,8.71-8.5,13.22-2.56-4.15-5.24-8.14-7.73-12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3554.98,443.01c-2.87-4.38-5.75-8.78-8.47-13.17,2.83-4.45,5.6-8.83,8.47-13.23,2.87,4.29,5.64,8.67,8.62,13.23-2.87,4.39-5.75,8.78-8.62,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3535.81,413.3c2.85-4.4,5.62-8.81,8.47-13.09,2.68,3.98,5.33,8.22,8.16,12.42-2.92,4.38-5.64,8.81-8.56,13.21-2.73-4.25-5.45-8.43-8.07-12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3849.31,530.1c-2.79,4.56-5.66,8.95-8.54,13.33-2.73-4.39-5.6-8.77-8.47-13.33,2.87-4.37,5.75-8.76,8.6-13.12,2.85,4.36,5.62,8.75,8.41,13.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3751.83,448.82c2.85,4.41,5.77,8.81,8.52,13.21-2.75,4.38-5.66,8.8-8.52,13.19-2.85-4.38-5.73-8.8-8.58-13.19,2.85-4.4,5.73-8.8,8.58-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3769.24,510.37c-3.09-1.28-6.13-2.1-9.02-2.37h-.19c1.25-2.05,2.51-4.06,3.85-6.04,1.8,2.84,3.63,5.65,5.37,8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3793.88,513.99c-1.9,2.99-3.82,5.93-5.62,8.77-3.57-2.91-6.99-5.6-10.46-7.79,2.71-4.3,5.56-8.62,8.35-13.01,2.58,4.12,5.16,8.11,7.73,12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3751.83,483.36c3.13,4.86,6.32,9.72,9.38,14.57-2.01,3.26-4.14,6.52-6.11,9.69-1.06,0-2.11-.08-3.28-.2-2.49-4.03-5.18-8.06-7.82-12.09,2.64-3.97,5.18-8,7.82-11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3804.95,531.3c-.97,1.66-1.88,3.14-3.06,4.8-3.32-3.61-6.89-7.11-10.31-10.37,1.63-2.49,3.28-5.01,4.97-7.59,2.92,4.38,5.64,8.77,8.41,13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3827.16,530.1c-3.13,4.66-5.94,9.19-8.83,13.69-2.71-4.06-5.35-8.23-8.11-12.5,2.98-4.45,5.83-9.07,8.79-13.69,2.79,4.27,5.43,8.44,8.16,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3746.5,507.06c-2.9-.08-6.15-.33-9.78-.53,1.65-2.38,3.28-4.74,4.73-7.17,1.67,2.61,3.32,5.22,5.05,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3723.34,505.87c-2.56-.06-5.33-.26-8.01-.36,1.23-2.12,2.49-4.09,3.82-6.16,1.4,2.13,2.85,4.35,4.18,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3730.36,482.11c2.73,4.39,5.64,8.83,8.47,13.22-2.39,3.67-4.78,7.34-7.08,10.93-.95,0-1.9-.09-3.04-.09-2.33-3.61-4.61-7.17-6.91-10.84,2.92-4.38,5.77-8.83,8.56-13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3708.84,483.36c2.64,3.97,5.16,8,7.71,11.97-2.07,3.32-4.29,6.64-6.38,9.84-1.16-.03-2.3-.03-3.42-.12-2.07-3.09-4.04-6.17-5.96-9.19,2.68-4.21,5.37-8.41,8.05-12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3805.36,496.33c-3.06,4.56-5.9,9.18-8.81,13.66-2.66-3.91-5.16-7.91-7.82-12.07,2.96-4.5,5.92-9,8.77-13.57,2.66,3.94,5.24,7.95,7.86,11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3786.44,467.1c2.83,4.38,5.71,8.77,8.47,13.21-2.94,4.53-5.83,9.03-8.77,13.66-2.79-4.38-5.64-8.83-8.5-13.22,2.85-4.59,5.92-9.18,8.79-13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3783.57,497.93c-2.89,4.51-5.77,8.9-8.62,13.33-2.73-4.44-5.62-8.82-8.37-13.33,2.75-4.37,5.64-8.82,8.37-13.21,2.85,4.39,5.73,8.83,8.62,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3772.49,480.75c-2.92,4.38-5.77,8.83-8.62,13.22-3.15-4.86-6.28-9.77-9.47-14.7,2.9-4.47,5.62-8.8,8.54-13.21,3.21,4.88,6.3,9.81,9.55,14.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3816.43,513.64c-2.98,4.62-5.92,9.12-8.83,13.68-2.79-4.45-5.71-8.83-8.58-13.33,2.98-4.47,5.94-9.07,8.92-13.57,2.87,4.38,5.6,8.83,8.5,13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3826.76,565.13c-.08.3-.3.56-.4.77-2.75-3.68-5.94-7.88-9.36-12.15.49-.56.84-1.28,1.33-1.81,2.9,4.5,5.71,8.89,8.43,13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3815.62,547.82c-.44.83-.93,1.54-1.46,2.38-2.87-3.59-6-7.23-9.21-10.79.97-1.36,1.75-2.61,2.64-4.09,2.71,4.27,5.39,8.36,8.03,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3851.19,567.56c2.92,4.53,5.73,8.97,8.52,13.27-.17.36-.44.66-.57.92l-16.02.68c-.34-.35-.49-.79-.7-1.12,2.85-4.53,5.71-9.13,8.77-13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3837.12,581.31s-.04.08-.04.08c-1.35-1.92-4.12-6.13-8.03-11.7.19-.15.19-.36.36-.48,2.71,4.03,5.18,8.11,7.71,12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3521.99,392.18c-1.42-2.31-2.96-4.52-4.29-6.67l8.05.93c-1.37,1.9-2.47,3.83-3.76,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3800.16,445.78c2.58-3.99,5.2-7.97,7.78-11.93,2.75,4.33,5.6,8.75,8.5,13.15-2.6,4-5.14,8.01-7.73,12.06-2.9-4.38-5.62-8.89-8.54-13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3854.55,530.1c2.56-3.94,5.16-7.97,7.73-11.96,2.71,3.99,5.2,8.02,7.84,11.96-2.64,4.04-5.24,8.06-7.84,12.12-2.47-3.96-5.18-7.9-7.73-12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3843.37,512.84c2.66-3.94,5.13-8.03,7.82-11.94,2.92,4.39,5.73,8.83,8.52,13.22-2.6,4.03-5.16,8.02-7.73,12.05-2.87-4.41-5.6-8.79-8.6-13.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3479.52,425.84c-2.9-4.4-5.75-8.82-8.62-13.11,2.79-4.24,5.43-8.42,8.09-12.51,2.79,4.28,5.68,8.7,8.62,13.09-2.77,4.17-5.43,8.38-8.09,12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3830.23,492.31c-2.92-4.39-5.79-8.83-8.62-13.16,2.64-4.04,5.16-8.11,7.8-12.06,2.9,4.38,5.64,8.77,8.56,13.21-2.64,4-5.22,8-7.73,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3811.29,463.06c2.64-3.99,5.14-8.04,7.8-12.05,2.51,4,5.16,8.05,7.67,12.05-2.51,4.04-5.16,7.95-7.67,11.94-2.66-3.99-5.16-7.9-7.8-11.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3509.12,446.52c-2.66,4.18-5.37,8.36-8.01,12.54-2.92-4.38-5.73-8.89-8.62-13.18,2.66-4.22,5.37-8.33,8.01-12.53,2.89,4.39,5.73,8.77,8.62,13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3460.18,396.28c2.79-4.21,5.43-8.38,8.16-12.53,2.64,4.05,5.35,8.11,8.07,12.43-2.64,4.14-5.3,8.32-8.07,12.42-2.79-4.17-5.45-8.27-8.16-12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3832.02,463.06c2.83-4.36,5.73-8.75,8.45-13.17,2.9,4.42,5.77,8.8,8.62,13.17-2.85,4.38-5.73,8.8-8.62,13.19-2.81-4.39-5.62-8.8-8.45-13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3862.29,550.2c2.9,4.55,5.75,8.97,8.62,13.27-3,4.5-5.73,8.92-8.62,13.3-2.75-4.3-5.52-8.69-8.6-13.3,2.87-4.32,5.73-8.72,8.6-13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3457.2,425.84c-2.75-4.25-5.39-8.36-8.09-12.38,2.88-4.39,5.71-8.85,8.62-13.13,2.58,3.98,5.24,8.11,8.01,12.31-2.85,4.38-5.71,8.81-8.54,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3489.91,449.89c2.79,4.42,5.64,8.8,8.52,13.17-2.87,4.38-5.73,8.89-8.52,13.19-2.85-4.39-5.64-8.8-8.5-13.19,2.85-4.36,5.64-8.75,8.5-13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3465.25,379c.21.29.3.43.49.76-2.66,4.1-5.37,8.27-8.14,12.53-2.66-4.15-5.22-8.16-7.76-11.96.57-1.05,1.35-2.01,1.96-3.04,3,.1,6.28.48,9.89,1.31l3.55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3487.34,480.4c-2.6,3.96-5.16,8-7.71,11.91-2.87-4.39-5.68-8.83-8.52-13.16,2.49-4.04,5.16-8.11,7.59-12.06,2.92,4.38,5.79,8.77,8.64,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3509.12,479.63c-2.89,4.39-5.73,8.77-8.54,13.21-2.73-4.21-5.43-8.36-8.09-12.44,2.9-4.4,5.71-8.83,8.62-13.3,2.64,4.2,5.35,8.33,8.01,12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3438.79,397.39c2.87-4.28,5.77-8.78,8.41-13.06,2.54,3.8,5.18,7.75,7.82,11.84-2.85,4.39-5.62,8.89-8.5,13.2-2.58-3.99-5.24-8.02-7.73-11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3476.18,463.06c-2.58,4.04-5.2,7.98-7.76,12.06-2.62-4.08-5.18-8.02-7.76-12.06,2.58-3.99,5.14-7.94,7.76-11.91,2.56,3.87,5.18,7.91,7.76,11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3454.64,429.93c-2.58,3.92-5.18,7.88-7.71,11.96-2.77-4.26-5.5-8.46-8.14-12.44,2.64-4.07,5.16-8.02,7.84-11.98,2.54,3.99,5.26,8.16,8.01,12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3465.74,447.01c-2.49,4-5.16,8.01-7.65,12.06-2.87-4.38-5.71-8.89-8.62-13.18,2.6-3.99,5.18-8.07,7.73-11.98,2.83,4.28,5.68,8.7,8.54,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3832.74,496.33c2.58-4.03,5.22-8.03,7.73-11.97,2.71,4.12,5.37,8.36,8.03,12.45-2.47,4.03-5.13,8-7.73,12.09-2.54-4.21-5.24-8.36-8.03-12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3676.34,458.04c-2.85-4.42-5.73-8.92-8.52-13.2,2.71-4.21,5.45-8.36,8.16-12.53,2.73,4.38,5.52,8.79,8.37,13.21-2.66,4.18-5.37,8.24-8.01,12.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3654.11,458.04c-2.62-4.05-5.2-8.04-7.73-12.09,2.79-4.4,5.71-8.78,8.45-13.07,2.6,3.91,5.16,7.91,7.71,11.96-2.85,4.39-5.71,8.78-8.43,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3657.43,428.89c2.68-4.24,5.41-8.41,8.11-12.52,2.58,3.89,5.07,7.91,7.73,11.94-2.66,4.11-5.37,8.28-8.01,12.49-2.73-4-5.28-8.01-7.84-11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3678.43,428.31c2.9-4.39,5.73-8.78,8.62-13.2,2.73,4.42,5.62,8.81,8.5,13.2-2.79,4.35-5.64,8.76-8.5,13.14-2.89-4.38-5.73-8.79-8.62-13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3613.5,427.23c2.45-3.98,5.14-8.02,7.63-12.01,2.92,4.46,5.9,8.96,8.81,13.67-2.49,3.9-5.22,7.9-7.69,11.91-3.02-4.57-5.94-9.17-8.75-13.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3602.29,410.03c2.6-4.05,5.24-7.99,7.73-11.95,2.79,4.31,5.58,8.59,8.52,13.1-2.6,4.04-5.05,7.91-7.73,11.95-2.92-4.4-5.73-8.82-8.52-13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3697.77,458.04c-2.7-4.28-5.49-8.34-8.14-12.52,2.85-4.42,5.73-8.82,8.47-13.21,2.68,4.17,5.37,8.33,8.11,12.53-2.81,4.39-5.6,8.78-8.45,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3633.34,458.04c-2.85-4.42-5.73-8.92-8.47-13.2,2.58-4.05,5.11-8.05,7.71-11.96,2.85,4.29,5.73,8.67,8.52,13.07-2.6,4.05-5.18,8.04-7.75,12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3635.24,428.89c2.79-4.5,5.64-8.89,8.43-13.3,2.85,4.42,5.73,8.8,8.62,13.3-2.89,4.28-5.77,8.67-8.62,13.04-2.89-4.36-5.7-8.76-8.43-13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3721.8,428.78c2.92-4.4,5.77-8.78,8.56-13.2,2.73,4.42,5.64,8.8,8.47,13.3-2.75,4.28-5.66,8.67-8.47,13.04-2.79-4.36-5.64-8.76-8.56-13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3744.09,428.89c2.96-4.71,5.79-9.21,8.79-13.67,2.6,3.99,5.07,7.91,7.71,12.01-2.85,4.4-5.79,8.99-8.77,13.57-2.58-4-5.18-8.01-7.73-11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3700.79,428.31c2.62-4.03,5.18-8.05,7.65-11.94,2.68,4.11,5.47,8.28,8.22,12.52-2.66,3.9-5.18,7.9-7.82,11.91-2.68-4.2-5.37-8.38-8.05-12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3754.41,444.84c2.94-4.61,5.94-9.19,8.81-13.57,2.83,4.28,5.64,8.71,8.47,13.09-2.83,4.55-5.73,9.05-8.75,13.67-2.92-4.42-5.64-8.81-8.54-13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3776.97,444.37c2.83-4.39,5.7-8.81,8.47-13.09,3.19,4.73,6.34,9.59,9.47,14.51-2.77,4.4-5.64,8.77-8.47,13.28-3.17-4.97-6.34-9.84-9.47-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3774.95,476.66c-3.02-4.88-6.28-9.77-9.36-14.63,2.87-4.6,5.81-9.06,8.81-13.59,3.04,4.89,6.28,9.73,9.47,14.62-2.98,4.48-5.94,9.1-8.92,13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3719.92,458.04c-2.9-4.42-5.62-8.81-8.43-13.2,2.51-4.05,5.18-8.05,7.67-11.96,2.85,4.29,5.73,8.67,8.58,13.07-2.58,4.05-5.16,8.04-7.82,12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3740.73,458.04c-2.64-4.05-5.28-8.04-7.84-12.09,2.92-4.4,5.77-8.78,8.64-13.07,2.47,3.91,5.11,7.91,7.65,11.96-2.81,4.39-5.64,8.78-8.45,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3797.49,476.25c-2.77-4.39-5.62-8.8-8.41-13.19,2.79-4.36,5.64-8.75,8.41-13.17,2.85,4.42,5.73,8.8,8.6,13.17-2.87,4.38-5.75,8.8-8.6,13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3554.98,451.01c2.62,4,5.13,8.05,7.82,12.05-2.68,4.04-5.13,7.98-7.82,12.06-2.47-4.11-5.18-8.02-7.63-12.06,2.45-3.99,5.16-8.04,7.63-12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3622.24,448.82c2.87,4.41,5.62,8.81,8.54,13.21-2.92,4.38-5.66,8.92-8.54,13.19-2.81-4.38-5.75-8.8-8.58-13.19,2.83-4.4,5.77-8.8,8.58-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3684.35,478.56c-2.75,4.35-5.64,8.77-8.37,13.18-2.71-4.11-5.45-8.26-8.16-12.47,2.79-4.38,5.66-8.8,8.52-13.21,2.64,4.21,5.35,8.26,8.01,12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3706.22,479.27c-2.75,4.21-5.43,8.36-8.11,12.47-2.83-4.41-5.62-8.82-8.47-13.18,2.79-4.24,5.43-8.29,8.14-12.5,2.85,4.41,5.64,8.74,8.45,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3708.84,448.82c2.87,4.41,5.71,8.81,8.58,13.21-2.87,4.38-5.71,8.8-8.58,13.19-2.87-4.38-5.71-8.8-8.54-13.19,2.83-4.4,5.66-8.8,8.54-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3687.06,449.49c2.66,4.24,5.37,8.3,8.01,12.53-2.64,4.21-5.35,8.29-8.01,12.5-2.71-4.21-5.37-8.29-8.07-12.5,2.71-4.23,5.37-8.29,8.07-12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3665.27,448.82c2.77,4.41,5.64,8.81,8.47,13.21-2.83,4.38-5.62,8.8-8.47,13.19-2.87-4.38-5.75-8.8-8.64-13.19,2.89-4.4,5.77-8.8,8.64-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3641.18,478.08c-2.87,4.38-5.75,8.77-8.6,13.21-2.49-3.96-5.14-8.05-7.71-12.02,2.85-4.38,5.62-8.77,8.47-13.21,2.58,3.96,5.16,8,7.84,12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3643.67,450.05c2.71,3.94,5.14,7.99,7.82,11.97-2.68,4.04-5.11,8-7.76,12.03-2.56-4.04-5.24-8-7.71-12.03,2.47-3.98,5.16-8.03,7.65-11.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3662.54,479.27c-2.56,4.09-5.11,8.06-7.61,12.02-2.85-4.44-5.77-8.82-8.56-13.21,2.54-4.03,5.11-8.06,7.73-12.02,2.73,4.41,5.58,8.74,8.43,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3727.74,478.08c-2.85,4.38-5.73,8.77-8.58,13.21-2.49-3.96-5.16-7.93-7.67-12.02,2.81-4.47,5.64-8.8,8.43-13.21,2.66,3.96,5.18,8,7.82,12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3785.45,423.13c-.25-.46-.55-.97-.97-1.45.61.22,1.16.33,1.75.48-.3.29-.59.69-.78.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3497.94,429.36c-2.68,4.07-5.37,8.27-8.16,12.53-2.54-4.15-5.11-8.04-7.61-11.96,2.66-4.21,5.37-8.46,8.01-12.53,2.51,3.93,5.2,7.88,7.75,11.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3819.09,443.01c-2.66-4.03-5.26-8.03-7.8-12.01,3.97,1.67,7.99,3.6,11.86,5.71-1.35,2.13-2.73,4.17-4.06,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3782.89,427.23c-2.79,4.29-5.64,8.67-8.5,13.11-2.87-4.44-5.73-8.82-8.62-13.11,1.92-3.05,3.8-5.9,5.75-8.78,2.22.5,4.4,1.08,6.68,1.63,1.61,2.37,3.15,4.68,4.69,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3873.36,559.5c-2.66-4.32-5.54-8.71-8.37-13.33,2.49-3.94,5.13-7.9,7.63-12.02,1.31,1.95,2.49,3.88,3.74,5.78.93,3.76,1.8,7.44,2.64,10.87-1.82,2.96-3.7,5.86-5.64,8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3862.29,510.08c-2.75-4.38-5.66-8.77-8.45-13.27,2.37-3.61,4.61-7.23,7.12-10.97,1.88,5.63,3.7,11.62,5.52,17.75-1.29,2.22-2.75,4.3-4.18,6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3872.62,526.16c-2.49-4.03-5.07-8.02-7.63-12.05.91-1.64,2.07-3.33,3.13-5.02,1.63,5.66,3.13,11.29,4.67,16.86q-.06.08-.17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3829.4,459.07c-2.64-4.05-5.16-8.05-7.8-12.06,1.8-2.75,3.61-5.45,5.35-8.14,3.83,2.23,7.44,4.71,10.71,7.41-2.81,4.32-5.56,8.51-8.26,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3851.19,492.83c-2.68-4.21-5.35-8.36-8.01-12.53,2.85-4.44,5.73-8.82,8.5-13.21,1.82,2.93,3.72,5.86,5.66,8.77.55,1.5,1.1,3.07,1.71,4.68-2.56,4.14-5.16,8.08-7.86,12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3805.36,429.84c-2.62,3.91-5.2,7.9-7.86,11.95-3.06-4.86-6.3-9.73-9.36-14.56.8-1.32,1.52-2.58,2.41-3.84,4.46,1.42,9.07,3.02,13.65,4.71.36.57.76,1.15,1.16,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3533.57,449.89c2.79,4.31,5.66,8.8,8.41,13.17-2.75,4.38-5.62,8.8-8.41,13.19-2.85-4.39-5.71-8.8-8.58-13.19,2.87-4.36,5.73-8.75,8.58-13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3552.44,479.15c-2.92,4.32-5.64,8.77-8.56,13.16-2.58-4-5.16-8-7.73-12,2.77-4.44,5.64-8.82,8.52-13.21,2.56,3.94,5.13,8.02,7.78,12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3514.28,446.52c2.85-4.4,5.73-8.78,8.62-13.17,2.66,4.11,5.37,8.32,8.01,12.53-2.9,4.38-5.75,8.79-8.54,13.18-2.75-4.18-5.45-8.43-8.09-12.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3536.07,445.89c2.66-3.99,5.24-8.07,7.82-12.04,2.79,4.33,5.64,8.75,8.56,13.15-2.64,4-5.22,8.01-7.78,12.06-2.87-4.51-5.75-8.89-8.6-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3763.3,423.13c-1.73-2.48-3.28-4.97-4.86-7.33,2.58.48,5.43,1.05,8.5,1.61-1.16,1.91-2.51,3.82-3.63,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3459.82,429.93c2.85-4.54,5.73-8.93,8.6-13.32,2.68,4.29,5.52,8.78,8.39,13.23-2.77,4.39-5.56,8.78-8.39,13.17-2.87-4.38-5.75-8.78-8.6-13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3487.34,445.89c-2.85,4.38-5.73,8.79-8.64,13.18-2.51-4.05-5.09-8.05-7.71-12.06,2.9-4.41,5.64-8.82,8.54-13.1,2.54,3.91,5.16,7.99,7.82,11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3573.89,480.3c-2.58,4-5.16,8-7.73,12-2.85-4.39-5.62-8.83-8.5-13.16,2.45-4.04,5.13-8.11,7.73-12.06,2.79,4.38,5.62,8.77,8.5,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3511.7,450.6c2.66,4.08,5.43,8.25,8.14,12.46-2.7,4.24-5.47,8.33-8.05,12.53-2.79-4.21-5.43-8.41-8.12-12.53,2.68-4.1,5.33-8.27,8.03-12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3530.91,480.3c-2.64,4.17-5.35,8.33-8.01,12.53-2.89-4.44-5.77-8.82-8.62-13.21,2.64-4.21,5.35-8.33,8.09-12.53,2.79,4.38,5.64,8.77,8.54,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3748.36,414.03c-2.26,3.55-4.54,7.08-6.83,10.72-2.81-4.21-5.54-8.39-8.24-12.56l7.25.89s3,.33,7.82.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3599.72,448.44c2.88,4.53,5.79,8.99,8.79,13.59-3.17,4.86-6.32,9.84-9.34,14.63-3.06-4.5-5.96-9.12-8.92-13.6,3.15-4.89,6.28-9.73,9.47-14.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3596.44,480.75c-2.85,4.38-5.68,8.83-8.6,13.22-2.87-4.63-5.73-9.13-8.75-13.66,2.83-4.44,5.73-8.82,8.58-13.21,2.85,4.47,5.81,9.07,8.77,13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3619.56,479.27c-3.06,4.92-6.3,9.84-9.32,14.7-2.9-4.38-5.73-8.83-8.64-13.22,3.3-4.88,6.3-9.81,9.47-14.69,2.87,4.41,5.66,8.74,8.5,13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3602.29,444.4c2.85-4.42,5.6-8.84,8.52-13.12,2.85,4.37,5.92,8.96,8.75,13.57-2.83,4.39-5.62,8.78-8.5,13.2-2.92-4.62-5.83-9.12-8.77-13.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3579.09,445.89c3.21-5.02,6.3-9.88,9.43-14.61,2.77,4.28,5.64,8.71,8.5,13.12-3.02,4.83-6.26,9.7-9.34,14.67-2.85-4.51-5.75-8.89-8.58-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3576.47,449.89c2.79,4.31,5.64,8.8,8.5,13.17-2.85,4.38-5.6,8.8-8.35,13.19-2.87-4.39-5.77-8.8-8.64-13.19,2.87-4.36,5.77-8.75,8.5-13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3557.66,447.01c2.87-4.41,5.64-8.82,8.5-13.15,2.58,3.96,5.09,7.94,7.73,12.04-2.87,4.38-5.71,8.79-8.56,13.18-2.54-4.05-5.22-8.05-7.67-12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3859.14,581.75l6.21-.26c-.17-.18-.36-.48-.46-.66,2.75-4.38,5.66-8.8,8.47-13.27,3,4.47,5.75,8.89,8.54,13.15l3.91-.06s-.19-1.07-.57-2.84c-3.06-4.68-6-9.36-9.19-14.34,1.48-2.17,2.87-4.45,4.42-6.78-.49-1.87-.93-3.76-1.46-5.9-1.82,2.96-3.7,5.86-5.64,8.71-2.66-4.32-5.54-8.71-8.37-13.33,2.49-3.94,5.13-7.9,7.63-12.02,1.31,1.95,2.49,3.88,3.74,5.78-1.18-4.51-2.43-9.21-3.57-13.96q-.06.08-.17.2c-2.49-4.03-5.07-8.02-7.63-12.05.91-1.64,2.07-3.33,3.13-5.02-.49-1.74-1.06-3.7-1.65-5.51-1.29,2.22-2.75,4.3-4.18,6.49-2.75-4.38-5.66-8.77-8.45-13.27,2.37-3.61,4.61-7.23,7.12-10.97-.68-1.71-1.25-3.55-1.9-5.29-2.56,4.14-5.16,8.08-7.86,12.29-2.68-4.21-5.35-8.36-8.01-12.53,2.85-4.44,5.73-8.82,8.5-13.21,1.82,2.93,3.72,5.86,5.66,8.77-1.54-4.09-3.09-7.91-4.61-11.15-3.28-7.09-8.58-13.12-15.07-18.44-2.81,4.32-5.56,8.51-8.26,12.79-2.64-4.05-5.16-8.05-7.8-12.06,1.8-2.75,3.61-5.45,5.35-8.14-1.25-.73-2.51-1.53-3.8-2.18-1.35,2.13-2.73,4.17-4.06,6.31-2.66-4.03-5.26-8.03-7.8-12.01-2.3-1.06-4.8-2.06-7.1-2.88.36.57.76,1.15,1.16,1.73-2.62,3.91-5.2,7.9-7.86,11.95-3.06-4.86-6.3-9.73-9.36-14.56.8-1.32,1.52-2.58,2.41-3.84-1.46-.37-2.98-.85-4.31-1.24-.3.29-.59.69-.78.97-.25-.46-.55-.97-.97-1.45-2.07-.57-4.18-1.13-6.28-1.61,1.61,2.37,3.15,4.68,4.69,7.15-2.79,4.29-5.64,8.67-8.5,13.11-2.87-4.44-5.73-8.82-8.62-13.11,1.92-3.05,3.8-5.9,5.75-8.78-1.52-.39-3.06-.69-4.59-1.05-1.16,1.91-2.51,3.82-3.63,5.73-1.73-2.48-3.28-4.97-4.86-7.33-3.91-.79-7.31-1.24-10.08-1.76-2.26,3.55-4.54,7.08-6.83,10.72-2.81-4.21-5.54-8.39-8.24-12.56l-5.73-.69c.17,0,.17.03.17.03-2.85,4.38-5.73,8.83-8.58,13.22-2.7-4.21-5.35-8.28-8.03-12.46.59-.91,1.14-1.8,1.69-2.62l-9.4-1.25c.85,1.31,1.61,2.54,2.56,3.87-2.68,3.97-5.18,7.96-7.86,11.98-2.83-4.38-5.68-8.89-8.47-13.22.85-1.32,1.69-2.63,2.56-3.95l-4.8-.61c-.15.17-.27.36-.34.61-.21-.25-.4-.55-.4-.68l-5.73-.79c1.12,1.84,2.28,3.63,3.42,5.42-2.75,4.38-5.54,8.83-8.37,13.22-2.71-4.03-5.28-8.01-7.86-11.98,1.71-2.56,3.25-5.05,4.95-7.61l-4.86-.57c-.85,1.45-1.78,2.74-2.66,4.21-1.06-1.76-2.18-3.36-3.15-4.97l-5.77-.68c2.11,3.17,4.23,6.38,6.34,9.62-2.66,4.17-5.35,8.35-8.14,12.46-2.85-4.39-5.73-8.83-8.45-13.11,1.94-3.21,3.97-6.37,6.09-9.52l-4.82-.55c-1.27,1.93-2.66,3.99-3.97,5.97-1.52-2.37-3.06-4.64-4.61-7.06l-5.62-.71c2.47,3.84,5.05,7.77,7.65,11.87-2.79,4.28-5.66,8.73-8.52,13.11-2.98-4.58-5.92-9.07-8.81-13.58,2.49-3.93,5.07-7.82,7.57-11.66l-4.86-.55c-1.75,2.74-3.42,5.45-5.35,8.22-2.11-3.24-4.21-6.52-6.36-9.69l-8.96-1.11c-1.97,3.28-3.99,6.41-6.09,9.59-2.49-3.76-5.01-7.6-7.46-11.33l-5.56-.69v.14c-2.85,4.28-5.75,8.7-8.58,13.08-2.87-4.38-5.75-8.8-8.41-13.08.38-.68.76-1.36,1.14-2.03l-8.43-1.02c.68,1.02,1.37,1.98,1.92,3.05-3.06,4.75-6.19,9.62-9.36,14.49-2.68-4.17-5.45-8.38-8.01-12.42,1.37-2.21,2.77-4.41,4.21-6.59l-4.92-.55c-.63,1.01-1.29,2.05-1.97,3.15-.76-1.33-1.5-2.49-2.41-3.71l-5.6-.68c1.67,2.73,3.63,5.53,5.33,8.38-2.79,4.31-5.54,8.7-8.41,13.1-2.83-4.41-5.75-8.79-8.6-13.1,2.01-3.06,4.04-6.13,5.92-9.04l-4.75-.69c-1.37,1.9-2.47,3.83-3.76,5.74-1.42-2.31-2.96-4.52-4.29-6.67l-5.73-.68c2.51,3.63,4.94,7.45,7.46,11.34-2.56,3.91-5.16,7.95-7.73,11.94-2.58-4.07-5.24-8.03-7.71-11.94,2.47-3.89,4.92-7.7,7.31-11.46l-4.84-.64c-1.73,2.71-3.47,5.33-5.18,8.11-2.11-3.3-4.08-6.41-6.13-9.49l-9.36-1.11c-2.22,3.5-4.46,7.03-6.8,10.6-2.73-4.18-5.39-8.43-8.09-12.43h0l-5.64-.76c.21.29.3.43.49.76-2.66,4.1-5.37,8.27-8.14,12.53-2.66-4.15-5.22-8.16-7.76-11.96.57-1.05,1.35-2.01,1.96-3.04-3.28-.11-6.15.1-8.83.57.59.81,1.18,1.57,1.75,2.47-2.87,4.38-5.77,8.71-8.6,13.18-2.01-3.13-4.04-6.18-5.92-9.17-1.25,1.23-2.13,2.48-2.9,3.67,2.03,3.05,4.1,6.22,6.23,9.39-1.65,2.69-3.34,5.29-5.07,7.88.49,1.84.93,3.79,1.33,6.01,2.09-3.28,4.18-6.59,6.32-9.85,2.51,3.94,5.16,7.94,7.82,11.97-2.58,3.99-5.16,8.03-7.67,11.98-1.67-2.55-3.32-5.02-4.94-7.55,1.25,5.41,2.58,11.2,3.99,17.06.29-.48.61-.99.95-1.47,2.62,4.13,5.28,8.24,8.03,12.46-1.5,2.27-2.94,4.45-4.4,6.76.57,1.9,1.1,3.81,1.52,5.65,1.94-2.77,3.68-5.65,5.5-8.41,2.73,4.42,5.64,8.8,8.47,13.17-2.68,4.3-5.33,8.51-8.03,12.63.3.86.68,1.68.97,2.48,1.94,3.82,3.72,6.78,5.62,9.01-1.4-2.35-2.98-4.6-4.5-6.78,2.92-4.4,5.75-8.83,8.62-13.3,2.49,3.94,5.16,8.02,7.71,12.06-2.56,3.99-5.14,8.03-7.71,12.02,1.35.95,2.66,1.66,3.83,2.13,2.11-3.41,4.4-6.7,6.51-10.16,2.47,3.71,4.78,7.44,7.27,11.3,2.11.08,4.56.17,7.63.23,2.11-3.38,4.37-6.82,6.59-10.31,2.39,3.64,4.67,7.29,7.16,10.97,2.09,0,4.52.23,6.91.35,2.64-4.03,5.13-8.05,7.8-12.09,2.71,4.27,5.35,8.54,8.14,12.74,1.82.1,3.7.18,5.73.24,2.62-4.07,5.26-8.18,7.92-12.21,2.49,3.94,5.16,7.95,7.73,11.97-.25.38-.44.66-.68.95,2.2.08,4.42.18,6.72.3-.27-.39-.55-.87-.85-1.25,2.83-4.38,5.6-8.8,8.47-13.19,2.87,4.38,5.75,8.8,8.62,13.19-.38.66-.89,1.25-1.27,1.92,2.6.12,5.24.15,7.95.39-.57-.8-.97-1.54-1.54-2.31,2.66-4.03,5.16-8.03,7.88-11.97,2.85,4.56,5.79,9.07,8.77,13.57-.3.48-.57.87-.91,1.34,2.43.08,4.73.21,7.04.33-.23-.51-.63-1.07-.99-1.67,2.87-4.37,5.73-8.82,8.64-13.21,2.73,4.39,5.62,8.83,8.37,13.21-.38.8-.91,1.55-1.44,2.28,2.75.1,5.62.33,8.39.41-.55-.88-1.1-1.74-1.67-2.69,3.13-4.85,6.3-9.71,9.42-14.57,2.62,3.97,5.2,8,7.73,11.97-1.2,1.96-2.47,3.88-3.72,5.86,1.75.12,3.34.12,4.97.23.57-.68.97-1.36,1.35-2.07.57.71.93,1.48,1.44,2.13,1.8.18,3.55.18,5.47.3-1.52-2.13-2.92-4.32-4.25-6.46,2.79-4.38,5.64-8.83,8.5-13.22,2.79,4.39,5.66,8.83,8.56,13.22-1.58,2.37-2.98,4.5-4.46,6.82,1.75.12,3.44.17,5.09.3.63-1.01,1.25-2.02,2.01-3.09.68,1.07,1.33,2.13,2.11,3.32,1.69,0,3.55.12,5.35.24-1.73-2.61-3.28-5.07-4.92-7.59,2.64-3.97,5.07-8,7.8-11.97,2.64,4.09,5.35,8.29,8.01,12.5-1.48,2.4-3.15,4.89-4.75,7.38,1.73.09,3.42.09,5.11.16.8-1.13,1.56-2.38,2.35-3.56.76,1.28,1.52,2.48,2.39,3.76,1.8.12,3.53.2,5.41.3-1.8-2.69-3.53-5.36-5.35-8.03,2.9-4.5,5.73-8.89,8.62-13.27,2.85,4.39,5.71,8.77,8.5,13.27-1.82,2.79-3.55,5.57-5.47,8.29,1.77.13,3.47.18,5.07.3,1.08-1.53,2.05-3.02,2.96-4.62,1.18,1.66,2.13,3.32,3.3,4.86,1.73.12,3.61.23,5.35.36-2.07-3.09-4.04-6.17-5.96-9.19,2.68-4.21,5.37-8.41,8.05-12.5,2.64,3.97,5.16,8,7.71,11.97-2.07,3.32-4.29,6.64-6.38,9.84,1.69.12,3.46.23,5.16.35,1.23-2.12,2.49-4.09,3.82-6.16,1.4,2.13,2.85,4.35,4.18,6.52,1.94.08,3.63.21,5.37.3-2.33-3.61-4.61-7.17-6.91-10.84,2.92-4.38,5.77-8.83,8.56-13.22,2.73,4.39,5.64,8.83,8.47,13.22-2.39,3.67-4.78,7.34-7.08,10.93,1.73.09,3.42.18,4.97.27,1.65-2.38,3.28-4.74,4.73-7.17,1.67,2.61,3.32,5.22,5.05,7.7,1.86.15,3.72.3,5.33.36-2.49-4.03-5.18-8.06-7.82-12.09,2.64-3.97,5.18-8,7.82-11.97,3.13,4.86,6.32,9.72,9.38,14.57-2.01,3.26-4.14,6.52-6.11,9.69,1.88.16,3.61.27,4.92.39,1.25-2.05,2.51-4.06,3.85-6.04,1.8,2.84,3.63,5.65,5.37,8.41,2.83,1.13,5.71,2.79,8.56,4.6,2.71-4.3,5.56-8.62,8.35-13.01,2.58,4.12,5.16,8.11,7.73,12.02-1.9,2.99-3.82,5.93-5.62,8.77,1.01,1.04,2.18,1.92,3.32,2.97,1.63-2.49,3.28-5.01,4.97-7.59,2.92,4.38,5.64,8.77,8.41,13.15-.97,1.66-1.88,3.14-3.06,4.8,1.18,1.13,2.09,2.17,3.06,3.32.97-1.36,1.75-2.61,2.64-4.09,2.71,4.27,5.39,8.36,8.03,12.5-.44.83-.93,1.54-1.46,2.38,1.01,1.18,1.99,2.43,2.83,3.55.49-.56.84-1.28,1.33-1.81,2.9,4.5,5.71,8.89,8.43,13.19-.08.3-.3.56-.4.77.95,1.3,1.78,2.55,2.68,3.79.19-.15.19-.36.36-.48,2.71,4.03,5.18,8.11,7.71,12.09-.04,0-.04.08-.04.08.49.72.74,1.22.74,1.22l5.3-.18c-.34-.35-.49-.79-.7-1.12,2.85-4.53,5.71-9.13,8.77-13.75,2.92,4.53,5.73,8.97,8.52,13.27-.17.36-.44.66-.57.92ZM3851.19,559.5c-2.58-3.91-5.16-7.91-7.82-12.09,2.87-4.38,5.73-8.71,8.6-13.27,2.58,4.12,5.13,8.18,7.73,12.02-2.85,4.51-5.73,8.95-8.52,13.33ZM3819.09,483.15c2.79,4.38,5.62,8.8,8.43,13.19-2.87,4.42-5.64,8.83-8.52,13.27-2.77-4.44-5.62-8.77-8.5-13.27,2.87-4.38,5.73-8.8,8.58-13.19ZM3807.93,492.31c-2.58-4-5.2-8-7.78-12,2.92-4.44,5.64-8.82,8.54-13.21,2.6,3.94,5.13,8.02,7.73,12.06-2.9,4.32-5.75,8.77-8.5,13.16ZM3830.23,500.42c2.64,4.15,5.3,8.29,8.01,12.42-2.92,4.53-5.75,8.92-8.56,13.32-2.64-4.17-5.35-8.38-8.07-12.52,2.83-4.38,5.71-8.83,8.62-13.22ZM3840.9,516.98c2.85,4.36,5.62,8.75,8.41,13.12-2.79,4.56-5.66,8.95-8.54,13.33-2.73-4.39-5.6-8.77-8.47-13.33,2.87-4.37,5.75-8.76,8.6-13.12ZM3832.02,565.13c2.96-4.5,5.79-9.07,8.75-13.66,2.68,4.12,5.26,8.09,7.73,12-2.94,4.71-5.87,9.3-8.75,13.68-2.49-3.79-5.18-7.82-7.73-12.02ZM3820.82,547.95c2.94-4.63,5.94-9.21,8.85-13.81,2.94,4.56,5.64,8.89,8.56,13.27-3,4.62-5.94,9.25-8.83,13.69-2.83-4.33-5.64-8.72-8.58-13.15ZM3810.22,531.3c2.98-4.45,5.83-9.07,8.79-13.69,2.79,4.27,5.43,8.44,8.16,12.5-3.13,4.66-5.94,9.19-8.83,13.69-2.71-4.06-5.35-8.23-8.11-12.5ZM3799.02,513.99c2.98-4.47,5.94-9.07,8.92-13.57,2.87,4.38,5.6,8.83,8.5,13.22-2.98,4.62-5.92,9.12-8.83,13.68-2.79-4.45-5.71-8.83-8.58-13.33ZM3788.72,497.93c2.96-4.5,5.92-9,8.77-13.57,2.66,3.94,5.24,7.95,7.86,11.97-3.06,4.56-5.9,9.18-8.81,13.66-2.66-3.91-5.16-7.91-7.82-12.07ZM3786.15,493.97c-2.79-4.38-5.64-8.83-8.5-13.22,2.85-4.59,5.92-9.18,8.79-13.65,2.83,4.38,5.71,8.77,8.47,13.21-2.94,4.53-5.83,9.03-8.77,13.66ZM3766.58,497.93c2.75-4.37,5.64-8.82,8.37-13.21,2.85,4.39,5.73,8.83,8.62,13.21-2.89,4.51-5.77,8.9-8.62,13.33-2.73-4.44-5.62-8.82-8.37-13.33ZM3754.41,479.27c2.9-4.47,5.62-8.8,8.54-13.21,3.21,4.88,6.3,9.81,9.55,14.69-2.92,4.38-5.77,8.83-8.62,13.22-3.15-4.86-6.28-9.77-9.47-14.7ZM3751.83,475.21c-2.85-4.38-5.73-8.8-8.58-13.19,2.85-4.4,5.73-8.8,8.58-13.21,2.85,4.41,5.77,8.81,8.52,13.21-2.75,4.38-5.66,8.8-8.52,13.19ZM3732.89,478.08c2.56-4.03,5.2-8.06,7.84-12.02,2.81,4.41,5.54,8.74,8.45,13.21-2.54,3.97-5.18,8.06-7.73,12.02-2.79-4.44-5.64-8.82-8.56-13.21ZM3722.58,462.02c2.58-3.98,5.16-8.03,7.78-11.97,2.54,3.94,5.09,7.99,7.73,11.97-2.64,4.04-5.2,8-7.73,12.03-2.62-4.04-5.2-8-7.78-12.03ZM3711.49,479.27c2.81-4.47,5.64-8.8,8.43-13.21,2.66,3.96,5.18,8,7.82,12.02-2.85,4.38-5.73,8.77-8.58,13.21-2.49-3.96-5.16-7.93-7.67-12.02ZM3708.84,475.21c-2.87-4.38-5.71-8.8-8.54-13.19,2.83-4.4,5.66-8.8,8.54-13.21,2.87,4.41,5.71,8.81,8.58,13.21-2.87,4.38-5.71,8.8-8.58,13.19ZM3689.63,478.56c2.79-4.24,5.43-8.29,8.14-12.5,2.85,4.41,5.64,8.74,8.45,13.21-2.75,4.21-5.43,8.36-8.11,12.47-2.83-4.41-5.62-8.82-8.47-13.18ZM3687.06,474.52c-2.71-4.21-5.37-8.29-8.07-12.5,2.71-4.23,5.37-8.29,8.07-12.53,2.66,4.24,5.37,8.3,8.01,12.53-2.64,4.21-5.35,8.29-8.01,12.5ZM3667.83,479.27c2.79-4.38,5.66-8.8,8.52-13.21,2.64,4.21,5.35,8.26,8.01,12.5-2.75,4.35-5.64,8.77-8.37,13.18-2.71-4.11-5.45-8.26-8.16-12.47ZM3665.27,475.21c-2.87-4.38-5.75-8.8-8.64-13.19,2.89-4.4,5.77-8.8,8.64-13.21,2.77,4.41,5.64,8.81,8.47,13.21-2.83,4.38-5.62,8.8-8.47,13.19ZM3646.38,478.08c2.54-4.03,5.11-8.06,7.73-12.02,2.73,4.41,5.58,8.74,8.43,13.21-2.56,4.09-5.11,8.06-7.61,12.02-2.85-4.44-5.77-8.82-8.56-13.21ZM3643.74,474.06c-2.56-4.04-5.24-8-7.71-12.03,2.47-3.98,5.16-8.03,7.65-11.97,2.71,3.94,5.14,7.99,7.82,11.97-2.68,4.04-5.11,8-7.76,12.03ZM3624.86,479.27c2.85-4.38,5.62-8.77,8.47-13.21,2.58,3.96,5.16,8,7.84,12.02-2.87,4.38-5.75,8.77-8.6,13.21-2.49-3.96-5.14-8.05-7.71-12.02ZM3622.24,475.21c-2.81-4.38-5.75-8.8-8.58-13.19,2.83-4.4,5.77-8.8,8.58-13.21,2.87,4.41,5.62,8.81,8.54,13.21-2.92,4.38-5.66,8.92-8.54,13.19ZM3611.07,458.04c-2.92-4.62-5.83-9.12-8.77-13.64,2.85-4.42,5.6-8.84,8.52-13.12,2.85,4.37,5.92,8.96,8.75,13.57-2.83,4.39-5.62,8.78-8.5,13.2ZM3601.6,480.75c3.3-4.88,6.3-9.81,9.47-14.69,2.87,4.41,5.66,8.74,8.5,13.21-3.06,4.92-6.3,9.84-9.32,14.7-2.9-4.38-5.73-8.83-8.64-13.22ZM3599.17,476.66c-3.06-4.5-5.96-9.12-8.92-13.6,3.15-4.89,6.28-9.73,9.47-14.62,2.88,4.53,5.79,8.99,8.79,13.59-3.17,4.86-6.32,9.84-9.34,14.63ZM3587.67,459.07c-2.85-4.51-5.75-8.89-8.58-13.18,3.21-5.02,6.3-9.88,9.43-14.61,2.77,4.28,5.64,8.71,8.5,13.12-3.02,4.83-6.26,9.7-9.34,14.67ZM3579.09,480.3c2.83-4.44,5.73-8.82,8.58-13.21,2.85,4.47,5.81,9.07,8.77,13.65-2.85,4.38-5.68,8.83-8.6,13.22-2.87-4.63-5.73-9.13-8.75-13.66ZM3576.62,476.25c-2.87-4.39-5.77-8.8-8.64-13.19,2.87-4.36,5.77-8.75,8.5-13.17,2.79,4.31,5.64,8.8,8.5,13.17-2.85,4.38-5.6,8.8-8.35,13.19ZM3565.33,459.07c-2.54-4.05-5.22-8.05-7.67-12.06,2.87-4.41,5.64-8.82,8.5-13.15,2.58,3.96,5.09,7.94,7.73,12.04-2.87,4.38-5.71,8.79-8.56,13.18ZM3557.66,479.15c2.45-4.04,5.13-8.11,7.73-12.06,2.79,4.38,5.62,8.77,8.5,13.21-2.58,4-5.16,8-7.73,12-2.85-4.39-5.62-8.83-8.5-13.16ZM3554.98,475.12c-2.47-4.11-5.18-8.02-7.63-12.06,2.45-3.99,5.16-8.04,7.63-12.05,2.62,4,5.13,8.05,7.82,12.05-2.68,4.04-5.13,7.98-7.82,12.06ZM3544.67,459.07c-2.87-4.51-5.75-8.89-8.6-13.18,2.66-3.99,5.24-8.07,7.82-12.04,2.79,4.33,5.64,8.75,8.56,13.15-2.64,4-5.22,8.01-7.78,12.06ZM3536.15,480.3c2.77-4.44,5.64-8.82,8.52-13.21,2.56,3.94,5.13,8.02,7.78,12.06-2.92,4.32-5.64,8.77-8.56,13.16-2.58-4-5.16-8-7.73-12ZM3533.57,476.25c-2.85-4.39-5.71-8.8-8.58-13.19,2.87-4.36,5.73-8.75,8.58-13.17,2.79,4.31,5.66,8.8,8.41,13.17-2.75,4.38-5.62,8.8-8.41,13.19ZM3522.37,459.07c-2.75-4.18-5.45-8.43-8.09-12.54,2.85-4.4,5.73-8.78,8.62-13.17,2.66,4.11,5.37,8.32,8.01,12.53-2.9,4.38-5.75,8.79-8.54,13.18ZM3514.28,479.63c2.64-4.21,5.35-8.33,8.09-12.53,2.79,4.38,5.64,8.77,8.54,13.21-2.64,4.17-5.35,8.33-8.01,12.53-2.89-4.44-5.77-8.82-8.62-13.21ZM3511.79,475.59c-2.79-4.21-5.43-8.41-8.12-12.53,2.68-4.1,5.33-8.27,8.03-12.46,2.66,4.08,5.43,8.25,8.14,12.46-2.7,4.24-5.47,8.33-8.05,12.53ZM3479.52,433.91c2.54,3.91,5.16,7.99,7.82,11.98-2.85,4.38-5.73,8.79-8.64,13.18-2.51-4.05-5.09-8.05-7.71-12.06,2.9-4.41,5.64-8.82,8.54-13.1ZM3468.42,443.01c-2.87-4.38-5.75-8.78-8.6-13.07,2.85-4.54,5.73-8.93,8.6-13.32,2.68,4.29,5.52,8.78,8.39,13.23-2.77,4.39-5.56,8.78-8.39,13.17ZM3482.18,429.93c2.66-4.21,5.37-8.46,8.01-12.53,2.51,3.93,5.2,7.88,7.75,11.96-2.68,4.07-5.37,8.27-8.16,12.53-2.54-4.15-5.11-8.04-7.61-11.96ZM3500.5,433.36c2.89,4.39,5.73,8.77,8.62,13.17-2.66,4.18-5.37,8.36-8.01,12.54-2.92-4.38-5.73-8.89-8.62-13.18,2.66-4.22,5.37-8.33,8.01-12.53ZM3492.49,480.4c2.9-4.4,5.71-8.83,8.62-13.3,2.64,4.2,5.35,8.33,8.01,12.53-2.89,4.39-5.73,8.77-8.54,13.21-2.73-4.21-5.43-8.36-8.09-12.44ZM3489.91,476.25c-2.85-4.39-5.64-8.8-8.5-13.19,2.85-4.36,5.64-8.75,8.5-13.17,2.79,4.42,5.64,8.8,8.52,13.17-2.87,4.38-5.73,8.89-8.52,13.19ZM3471.11,479.15c2.49-4.04,5.16-8.11,7.59-12.06,2.92,4.38,5.79,8.77,8.64,13.3-2.6,3.96-5.16,8-7.71,11.91-2.87-4.39-5.68-8.83-8.52-13.16ZM3460.67,463.06c2.58-3.99,5.14-7.94,7.76-11.91,2.56,3.87,5.18,7.91,7.76,11.91-2.58,4.04-5.2,7.98-7.76,12.06-2.62-4.08-5.18-8.02-7.76-12.06ZM3449.47,445.89c2.6-3.99,5.18-8.07,7.73-11.98,2.83,4.28,5.68,8.7,8.54,13.1-2.49,4-5.16,8.01-7.65,12.06-2.87-4.38-5.71-8.89-8.62-13.18ZM3446.64,417.48c2.54,3.99,5.26,8.16,8.01,12.46-2.58,3.92-5.18,7.88-7.71,11.96-2.77-4.26-5.5-8.46-8.14-12.44,2.64-4.07,5.16-8.02,7.84-11.98ZM3455.03,396.18c-2.85,4.39-5.62,8.89-8.5,13.2-2.58-3.99-5.24-8.02-7.73-11.98,2.87-4.28,5.77-8.78,8.41-13.06,2.54,3.8,5.18,7.75,7.82,11.84ZM3457.73,400.32c2.58,3.98,5.24,8.11,8.01,12.31-2.85,4.38-5.71,8.81-8.54,13.21-2.75-4.25-5.39-8.36-8.09-12.38,2.88-4.39,5.71-8.85,8.62-13.13ZM3476.41,396.18c-2.64,4.14-5.3,8.32-8.07,12.42-2.79-4.17-5.45-8.27-8.16-12.31,2.79-4.21,5.43-8.38,8.16-12.53,2.64,4.05,5.35,8.11,8.07,12.43ZM3478.99,400.21c2.79,4.28,5.68,8.7,8.62,13.09-2.77,4.17-5.43,8.38-8.09,12.53-2.9-4.4-5.75-8.82-8.62-13.11,2.79-4.24,5.43-8.42,8.09-12.51ZM3498.68,396.18c-2.75,4.31-5.64,8.7-8.49,13.1-2.85-4.41-5.71-8.79-8.58-13.1,2.87-4.41,5.73-8.82,8.58-13.15,2.7,4.3,5.56,8.69,8.49,13.15ZM3509.12,412.19c-2.89,4.28-5.73,8.71-8.62,13.09-2.56-4.06-5.11-8-7.71-11.88,2.9-4.5,5.71-8.92,8.5-13.2,2.58,3.91,5.18,7.8,7.84,11.98ZM3511.7,416.17c2.79,4.31,5.66,8.64,8.5,13.2-2.83,4.38-5.64,8.78-8.5,13.17-2.87-4.38-5.64-8.89-8.5-13.17,2.85-4.43,5.62-8.81,8.5-13.2ZM3530.51,413.3c-2.49,3.98-5.16,8.03-7.61,11.98-2.98-4.43-5.77-8.81-8.62-13.09,2.6-4.08,5.16-8.07,7.71-11.98,2.81,4.28,5.68,8.7,8.52,13.09ZM3533.19,417.4c2.68,4.07,5.33,8.23,8.05,12.44-2.51,4.02-5.18,7.9-7.67,11.95-2.77-4.23-5.56-8.36-8.14-12.43,2.58-4.08,5.2-8.03,7.76-11.96ZM3552.44,412.63c-2.92,4.38-5.64,8.81-8.56,13.21-2.73-4.25-5.45-8.43-8.07-12.53,2.85-4.4,5.62-8.81,8.47-13.09,2.68,3.98,5.33,8.22,8.16,12.42ZM3554.98,416.61c2.87,4.29,5.64,8.67,8.62,13.23-2.87,4.39-5.75,8.78-8.62,13.17-2.87-4.38-5.75-8.78-8.47-13.17,2.83-4.45,5.6-8.83,8.47-13.23ZM3575.65,411.18c-3.28,4.85-6.34,9.72-9.55,14.66-2.87-4.5-5.66-8.89-8.43-13.21,3.06-4.88,6.28-9.72,9.36-14.55,2.77,4.31,5.62,8.59,8.62,13.1ZM3578.12,415.22c2.66,3.88,5.16,7.91,7.84,12.01-3.17,4.83-6.3,9.7-9.49,14.56-2.58-4.05-5.16-8.04-7.73-11.95,3.28-4.9,6.28-9.76,9.38-14.62ZM3597.01,410.03c-2.85,4.28-5.62,8.71-8.5,13.22-2.56-4.15-5.24-8.14-7.73-12.07,2.87-4.37,5.77-8.79,8.52-13.1,2.58,3.85,5.07,7.87,7.71,11.95ZM3599.72,414.03c2.73,4.33,5.62,8.71,8.5,13.2-2.75,4.29-5.62,8.67-8.5,13.11-2.89-4.44-5.73-8.82-8.62-13.11,2.89-4.49,5.73-8.86,8.62-13.2ZM3618.55,411.18c-2.6,4.04-5.05,7.91-7.73,11.95-2.92-4.4-5.73-8.82-8.52-13.1,2.6-4.05,5.24-7.99,7.73-11.95,2.79,4.31,5.58,8.59,8.52,13.1ZM3629.94,428.89c-2.49,3.9-5.22,7.9-7.69,11.91-3.02-4.57-5.94-9.17-8.75-13.57,2.45-3.98,5.14-8.02,7.63-12.01,2.92,4.46,5.9,8.96,8.81,13.67ZM3632.58,432.88c2.85,4.29,5.73,8.67,8.52,13.07-2.6,4.05-5.18,8.04-7.75,12.09-2.85-4.42-5.73-8.92-8.47-13.2,2.58-4.05,5.11-8.05,7.71-11.96ZM3652.29,428.89c-2.89,4.28-5.77,8.67-8.62,13.04-2.89-4.36-5.7-8.76-8.43-13.04,2.79-4.5,5.64-8.89,8.43-13.3,2.85,4.42,5.73,8.8,8.62,13.3ZM3654.83,432.88c2.6,3.91,5.16,7.91,7.71,11.96-2.85,4.39-5.71,8.78-8.43,13.2-2.62-4.05-5.2-8.04-7.73-12.09,2.79-4.4,5.71-8.78,8.45-13.07ZM3673.28,428.31c-2.66,4.11-5.37,8.28-8.01,12.49-2.73-4-5.28-8.01-7.84-11.91,2.68-4.24,5.41-8.41,8.11-12.52,2.58,3.89,5.07,7.91,7.73,11.94ZM3675.98,432.31c2.73,4.38,5.52,8.79,8.37,13.21-2.66,4.18-5.37,8.24-8.01,12.52-2.85-4.42-5.73-8.92-8.52-13.2,2.71-4.21,5.45-8.36,8.16-12.53ZM3695.55,428.31c-2.79,4.35-5.64,8.76-8.5,13.14-2.89-4.38-5.73-8.79-8.62-13.14,2.9-4.39,5.73-8.78,8.62-13.2,2.73,4.42,5.62,8.81,8.5,13.2ZM3698.11,432.31c2.68,4.17,5.37,8.33,8.11,12.53-2.81,4.39-5.6,8.78-8.45,13.2-2.7-4.28-5.49-8.34-8.14-12.52,2.85-4.42,5.73-8.82,8.47-13.21ZM3716.66,428.89c-2.66,3.9-5.18,7.9-7.82,11.91-2.68-4.2-5.37-8.38-8.05-12.49,2.62-4.03,5.18-8.05,7.65-11.94,2.68,4.11,5.47,8.28,8.22,12.52ZM3727.74,445.95c-2.58,4.05-5.16,8.04-7.82,12.09-2.9-4.42-5.62-8.81-8.43-13.2,2.51-4.05,5.18-8.05,7.67-11.96,2.85,4.29,5.73,8.67,8.58,13.07ZM3738.83,428.89c-2.75,4.28-5.66,8.67-8.47,13.04-2.79-4.36-5.64-8.76-8.56-13.14,2.92-4.4,5.77-8.78,8.56-13.2,2.73,4.42,5.64,8.8,8.47,13.3ZM3749.19,444.84c-2.81,4.39-5.64,8.78-8.45,13.2-2.64-4.05-5.28-8.04-7.84-12.09,2.92-4.4,5.77-8.78,8.64-13.07,2.47,3.91,5.11,7.91,7.65,11.96ZM3760.6,427.23c-2.85,4.4-5.79,8.99-8.77,13.57-2.58-4-5.18-8.01-7.73-11.91,2.96-4.71,5.79-9.21,8.79-13.67,2.6,3.99,5.07,7.91,7.71,12.01ZM3771.69,444.37c-2.83,4.55-5.73,9.05-8.75,13.67-2.92-4.42-5.64-8.81-8.54-13.2,2.94-4.61,5.94-9.19,8.81-13.57,2.83,4.28,5.64,8.71,8.47,13.09ZM3783.86,463.06c-2.98,4.48-5.94,9.1-8.92,13.6-3.02-4.88-6.28-9.77-9.36-14.63,2.87-4.6,5.81-9.06,8.81-13.59,3.04,4.89,6.28,9.73,9.47,14.62ZM3794.92,445.78c-2.77,4.4-5.64,8.77-8.47,13.28-3.17-4.97-6.34-9.84-9.47-14.7,2.83-4.39,5.7-8.81,8.47-13.09,3.19,4.73,6.34,9.59,9.47,14.51ZM3797.49,449.89c2.85,4.42,5.73,8.8,8.6,13.17-2.87,4.38-5.75,8.8-8.6,13.19-2.77-4.39-5.62-8.8-8.41-13.19,2.79-4.36,5.64-8.75,8.41-13.17ZM3816.43,447.01c-2.6,4-5.14,8.01-7.73,12.06-2.9-4.38-5.62-8.89-8.54-13.28,2.58-3.99,5.2-7.97,7.78-11.93,2.75,4.33,5.6,8.75,8.5,13.15ZM3826.76,463.06c-2.51,4.04-5.16,7.95-7.67,11.94-2.66-3.99-5.16-7.9-7.8-11.94,2.64-3.99,5.14-8.04,7.8-12.05,2.51,4,5.16,8.05,7.67,12.05ZM3829.4,467.1c2.9,4.38,5.64,8.77,8.56,13.21-2.64,4-5.22,8-7.73,12-2.92-4.39-5.79-8.83-8.62-13.16,2.64-4.04,5.16-8.11,7.8-12.06ZM3840.48,476.25c-2.81-4.39-5.62-8.8-8.45-13.19,2.83-4.36,5.73-8.75,8.45-13.17,2.9,4.42,5.77,8.8,8.62,13.17-2.85,4.38-5.73,8.8-8.62,13.19ZM3848.51,496.81c-2.47,4.03-5.13,8-7.73,12.09-2.54-4.21-5.24-8.36-8.03-12.56,2.58-4.03,5.22-8.03,7.73-11.97,2.71,4.12,5.37,8.36,8.03,12.45ZM3859.71,514.12c-2.6,4.03-5.16,8.02-7.73,12.05-2.87-4.41-5.6-8.79-8.6-13.32,2.66-3.94,5.13-8.03,7.82-11.94,2.92,4.39,5.73,8.83,8.52,13.22ZM3862.29,542.22c-2.47-3.96-5.18-7.9-7.73-12.12,2.56-3.94,5.16-7.97,7.73-11.96,2.71,3.99,5.2,8.02,7.84,11.96-2.64,4.04-5.24,8.06-7.84,12.12ZM3862.29,576.77c-2.75-4.3-5.52-8.69-8.6-13.3,2.87-4.32,5.73-8.72,8.6-13.27,2.9,4.55,5.75,8.97,8.62,13.27-3,4.5-5.73,8.92-8.62,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3278.44,392.74h-8.58s-6.13,4.23.55,10.06h7.44l.59-10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3292.22,374.67c.76,0,1.52,0,2.3.22v45.86c-.78.11-1.54.15-2.3.15-10.33,0-15.89-8.71-18.75-18.62v-8.96c0-10.3,8.41-18.65,18.75-18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M3294.53,374.9s10.76,3.3,10.76,22.92c.11,21.58-10.76,22.94-10.76,22.94v-45.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M3296.51,378.19s7.54,7.47,6.76,25.32c0,0-1.31-10.77-6.76-14.29v-11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2801.72,39.95h8.5s6.21,4.21-.44,10.04h-7.4l-.66-10.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2787.96,21.92c-.87,0-1.63,0-2.37.07v45.97c.74.06,1.5.06,2.37.06,10.23,0,15.74-8.71,18.64-18.65v-8.96c0-10.23-8.41-18.5-18.64-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2785.6,22s-10.71,3.33-10.8,22.97c0,21.55,10.8,23,10.8,23V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2783.65,25.33s-7.61,7.52-6.89,25.39c0,0,1.37-10.77,6.89-14.33v-11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2374.47,931.96h1626.46c24.58,0,23.25-52.37,23.25-52.37,0,0-14.56-8.14-20.9-31.72-3.97-14.69-.97-17.94-.89-31.4,0-7.1,23.12,2.26,23.12-4.44,0-18.62-.38-34.49-1.33-41.42-2.87-21.83-39.2-17.41-39.2-17.41h-632.28s-143.91-673.01-157.01-713.65c-13.08-40.67-63.95-34.97-63.95-34.97h-303.73c-20.35-1.42-26.2,16.07-26.2,16.07,0,0-7.23,27.57-8.69,43.58-1.42,15.95,8.69,14.49,8.69,14.49h17.41l-42.05,234.07h-213.67c-87.23,4.38-98.18,80.63-98.18,80.63l-90.85,538.53ZM2842.95,103.46c4.33-22.9,28.3-23.85,28.3-23.85h62.13c22.93,0,26.16,34.78,26.16,34.78,0,0,3.66,114.65,7.67,236.08h-160.37l36.12-247.01ZM2946.46,660.46h-156.97c-29.46-2.11-21.72-42.48-21.72-42.48l34.95-239.39h165.32c3.93,118.87,7.86,236.43,8.92,252.51,2.09,33.75-30.49,29.35-30.49,29.35ZM3177.58,453.73h-171.59c-14.52-1.47-15.3-23.25-15.3-23.25,0,0-15.19-303.78-13.74-329.94,1.54-26.1,30.58-20.35,30.58-20.35h74.15s14.12.37,34.89-.48c20.71-.99,25.02,17.2,25.02,17.2,0,0,54.54,307.38,58.85,331.39,4.37,23.95-22.87,25.42-22.87,25.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2440.04,543.56c295.17-.36,380.3,283.52,380.3,283.52h435.01c16.99-71.81,57.14-138.04,77.2-168.13,12.24,57.21,20.16,94.25,20.16,94.25h632.28s36.33-4.42,39.2,17.41c.95,6.93,1.33,22.8,1.33,41.42,0,6.7-23.12-2.66-23.12,4.44-.08,13.46-3.09,16.72.89,31.4,6.34,23.58,20.9,31.72,20.9,31.72,0,0,1.33,52.37-23.25,52.37h-1626.46l65.57-388.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2394.93,810.62l4.67-27.62h1625.43c.3,7.46.49,17.12.49,27.62h-1630.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2411.13,714.68l5.22-30.58h921.53c2.45,11.47,4.61,21.68,6.49,30.58h-933.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M4003.89,849.78c6.61,22.17,20.29,29.82,20.29,29.82,0,0,1.33,52.37-23.25,52.37h-1626.46l13.91-82.18h1615.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M3029.25,9.74h117.05s34.89-1.43,46.53,39.97c11.67,41.47,136.64,637.37,136.64,637.37l-173.71-596.7s-4.44-39.89-39.98-42.16c-35.61-2.14-272.54,0-272.54,0,0,0-24.03-7.23-26.12-28.33,0,0-3.63-10.15,17.37-10.15h194.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2946.31,80.2h13.93s9.09-1.73,17.35,1.13c4.06,4.43,8.07,8.71,12.07,12.99.61,1.93.97,3.95,1.16,6.23.19,3.46,0,11.37-.19,22.71-14.62-14.46-29.42-28.84-44.31-43.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2752.72,691.18c0,9.93,8.03,17.98,17.98,17.98h478.5c9.95,0,18.09-8.05,18.09-17.98h0c0-10.04-8.14-18.07-18.09-18.07h-478.5c-9.95,0-17.98,8.03-17.98,18.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2752.72,696.53c0,7.08,8.03,12.64,17.98,12.64h478.5c9.95,0,18.09-5.56,18.09-12.64h0c0-6.99-8.14-12.66-18.09-12.66h-478.5c-9.95,0-17.98,5.66-17.98,12.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M3187.49,49.99s-5.37-33.15-46.83-35.35h-281.33s-13.57.57-5.35,4.91c8.26,4.38,282.85,5.78,282.85,5.78,0,0,20.75-1.26,34.85,19.64,0,0,6.04,11.73,14.26,11.61,3.42,0,1.54-6.59,1.54-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2752.72,346.2l-54.5,268.82s-102.81-91.08-224.32-84l19.27-129.24s29.46-68.64,102.24-64.25c72.65,4.29,157.31,8.67,157.31,8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2744.09,352.9l-49.89,251.66s-90.21-80.62-214.32-80.62l18.05-115.61s27.73-69.36,100.36-65.05c72.82,4.4,145.81,9.62,145.81,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2766.83,319.1l-195.73.24s-76.24-3.99-97.21,72.43c0,0,34.38-64.07,93.93-64.28,59.59-.21,197.59,3.02,197.59,3.02l1.42-11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M3212.07,929.77v-220.6h-21.91v31.59h-191.27v-31.59h-21.79v220.6h21.79v-43.79h191.27v43.79h21.91ZM3190.15,859.5h-191.27v-92.26h191.27v92.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2977.1,
    y: 727.57,
    width: 234.97,
    height: 27.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 2990.81,
    y: 731.4,
    width: 206,
    height: 4.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2977.1,
    y: 849.38,
    width: 234.97,
    height: 27.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2977.1,
    y: 971.12,
    width: 234.97,
    height: 27.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 3200,
    y: 695.3,
    width: 23.96,
    height: 336.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2965.05,
    y: 695.3,
    width: 24.03,
    height: 336.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 2990.81,
    y: 853.46,
    width: 206,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 2990.81,
    y: 978.12,
    width: 206,
    height: 4.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 3210.23,
    y: 699.36,
    width: 8.01,
    height: 327.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 2977.1,
    y: 699.36,
    width: 7.99,
    height: 327.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3837.81,582.6s-29.8-42.34-46.24-56.88c0,0-16.63-17.01-39.75-18.31-23.12-1.25-264.49-11.97-264.49-11.97l251.5,18.36s27.32,1.25,44.06,13.51c16.72,12.2,54.92,55.28,54.92,55.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M3941.43,621l-36.9-135.16s-17.84-64.05-66.86-80.57c0,0-82.42-22.93-212.8-40.65-130.43-17.62-191.31-27.1-191.31-27.1l283.87,49.83,104.54,21.24s41.48,11.49,59.25,49.45c21.22,45.29,60.21,162.96,60.21,162.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3149.47,80.75s-7.82-21.8-34.97-21.8h-247.75s-34.97-1.43-39.64,17.52c-4.8,18.83-88.31,553.75-88.31,553.75,0,0-10.14,42.33,31.15,44.42h446.25s27.92-6.47,26.16-31.53l-92.88-562.36ZM2842.36,103.46c4.33-22.9,28.3-23.85,28.3-23.85h62.11c22.95,0,26.16,34.78,26.16,34.78,0,0,3.66,114.65,7.67,236.08h-160.37l36.14-247.01ZM2945.84,660.46h-156.97c-29.44-2.11-21.7-42.48-21.7-42.48l34.95-239.39h165.3c3.95,118.87,7.86,236.43,8.92,252.51,2.09,33.75-30.49,29.35-30.49,29.35ZM3176.97,453.73h-171.57c-14.54-1.47-15.32-23.25-15.32-23.25,0,0-15.19-303.78-13.74-329.94,1.54-26.1,30.6-20.35,30.6-20.35h74.13s14.14.37,34.89-.48c20.71-.99,25.02,17.2,25.02,17.2,0,0,54.54,307.38,58.85,331.39,4.4,23.95-22.87,25.42-22.87,25.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M3140.98,96.92s-4.31-18.19-25.02-17.2c-20.75.85-34.89.48-34.89.48h-74.13s-29.06-5.75-30.6,20.35c-1.46,26.16,13.74,329.94,13.74,329.94,0,0,.78,21.78,15.32,23.25h171.57s27.26-1.47,22.87-25.42c-4.31-24.01-58.85-331.39-58.85-331.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2990.69,435.27c38.8-37.09,78.7-72.9,118.47-108.83,20.82-18.83,41.69-37.7,62.47-56.38-7.16-40.64-14.48-81.78-20.14-113.83-56.11,52.74-111.98,105.69-166.92,159.69,2.85,62.68,5.52,114.57,5.52,114.57,0,0,.13,2.05.61,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2958.92,114.4s-3.21-34.78-26.16-34.78h-62.11s-23.96.95-28.3,23.85l-36.14,247.01h160.37c-4.02-121.43-7.67-236.08-7.67-236.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2949.61,350.48h16.99c-.21-5.4-.4-10.83-.57-16.34-5.56,5.5-10.9,10.94-16.42,16.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2959.71,140.18c-.49-16.35-.78-25.78-.78-25.78v-.21c-19.84,21.11-39.71,42.15-59.51,63.36-27.24,29.26-54.18,58.63-80.87,88.49l-3.7,25.18c47.78-50.87,95.96-101.33,144.86-151.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2967.42,378.59h-165.3l-34.95,239.39s-7.73,40.36,21.7,42.48h156.97s32.59,4.4,30.49-29.35c-1.06-16.08-4.97-133.64-8.92-252.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2816.37,610.46c47.78-46.46,93.34-94.93,140.36-142.03,4.35-4.27,8.81-8.68,13.29-13.01-.93-24.83-1.75-50.82-2.6-76.83h-45.65c-46.53,47.14-92.43,94.81-137.61,143.28-1.2,1.25-2.37,2.43-3.55,3.82l-13.44,92.28s-4.02,21.39,5.16,33.92c14.9-13.57,29.63-27.46,44.04-41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M3117.37,88.45c11.39,0,14.54,8.34,15.11,10.37,2.09,12.12,54.58,307.69,58.85,331.12,1.04,5.97-.95,8.5-1.54,9.37-3.28,4.07-10.48,5.54-13.16,5.74h-170.66c-6.11-1.11-7.08-14.75-7.08-14.93-5.35-104.89-14.9-308.76-13.76-329.12.19-3.73.68-12.54,15.09-12.54,2.85,0,4.97.35,4.97.35h0l.89.18h82.67c6.06,0,15.74-.11,27.49-.53h1.14ZM3117.37,79.62c-.49,0-.93,0-1.42.11-11.6.48-21.15.58-27.22.58-4.88,0-7.67-.11-7.67-.11h-74.13s-2.81-.48-6.72-.48c-8.62,0-22.82,2.75-23.88,20.83-1.46,26.16,13.74,329.94,13.74,329.94,0,0,.78,21.78,15.32,23.25h171.57s27.26-1.47,22.87-25.42c-4.31-24.01-58.85-331.39-58.85-331.39,0,0-4.1-17.31-23.6-17.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2932.76,88.45c2.09,0,8.41,0,13.57,11.62,2.85,6.66,3.82,13.64,3.93,14.91.17,6.68,3.53,112.52,7.27,226.83h-141.16l34.51-236.88c2.94-14.9,17.88-16.45,19.97-16.48h61.92ZM2932.76,79.62h-62.11s-23.96.95-28.3,23.85l-36.14,247.01h160.37c-4.02-121.43-7.67-236.08-7.67-236.08,0,0-3.21-34.78-26.16-34.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2958.92,387.32c4.97,148.89,7.88,231.05,8.64,244.32.44,6.96-.89,12.12-3.82,15.4-4.04,4.31-10.71,4.97-14.37,4.97-1.44,0-2.37-.11-2.37-.11h0l-.59-.08h-157.18c-4.4-.38-7.54-1.92-9.76-4.92-5.92-7.52-4.67-22.21-3.8-27.31l.13-.23.06-.12,33.83-231.91h149.24ZM2967.42,378.59h-165.3l-34.95,239.39s-7.73,40.36,21.7,42.48h156.97s1.46.25,3.53.25c8.45,0,28.59-2.85,26.96-29.61-1.06-16.08-4.97-133.64-8.92-252.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M3232.25,651.01c0,4.95-4.14,9.11-9.19,9.11s-8.98-4.16-8.98-9.11,4.04-9.02,8.98-9.02,9.19,4.02,9.19,9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M3214.46,559.02c0,5.09-4.04,9.07-9,9.07s-9.13-3.97-9.13-9.07,3.99-9.1,9.13-9.1,9,4.12,9,9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M3197.63,468.13c0,5.09-4.02,9.12-9,9.12s-9.13-4.03-9.13-9.12,4.1-9.07,9.13-9.07,9,3.99,9,9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M3001.51,651.01c0,4.95-4.12,9.11-9.09,9.11s-9.11-4.16-9.11-9.11,4.04-9.02,9.11-9.02,9.09,4.02,9.09,9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M3122.93,651.01c0,4.95-4.23,9.11-9.19,9.11s-9.11-4.16-9.11-9.11,4.16-9.02,9.11-9.02,9.19,4.02,9.19,9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2788.87,660.46h156.97s32.59,4.4,30.49-29.35c-1.06-16.08-4.97-133.64-8.92-252.51h-165.3l-34.95,239.39s-7.73,40.36,21.7,42.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2958.92,114.4s-3.21-34.78-26.16-34.78h-62.11s-23.96.95-28.3,23.85l-36.14,247.01h160.37c-4.02-121.43-7.67-236.08-7.67-236.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3005.39,453.73h171.57s27.26-1.47,22.87-25.42c-4.31-24.01-58.85-331.39-58.85-331.39,0,0-4.31-18.19-25.02-17.2-20.75.85-34.89.48-34.89.48h-74.13s-29.06-5.75-30.6,20.35c-1.46,26.16,13.74,329.94,13.74,329.94,0,0,.78,21.78,15.32,23.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "3190.39 312.8 3253.47 655.05 3265.89 643.32 3190.39 312.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M3354.92,948.68c0,150.25,121.83,272.1,272.18,272.1s272.2-121.85,272.2-272.1-121.81-272.23-272.2-272.23-272.18,121.95-272.18,272.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3361.77,951.45v-12.7l-16.44,2.75c.82-33.28,7.46-65.13,18.83-94.61l18.03,1.35,4.92-11.66-16.97-3.97c13.42-29.5,31.55-56.21,53.65-79.25l16.61,8.39,9.11-8.85-14.56-10.5c23.82-22.21,51.39-40.38,81.74-53.3l12.3,14.71,11.85-4.67-9.53-15.7c27.79-10.12,57.56-15.81,88.61-16.59l6.06,18.11h12.7l-3.11-18.05c33.43.93,65.47,7.8,94.93,19.46l-1.44,18.98,11.77,4.94,4.08-17.86c29.46,13.61,56.23,32.1,79.18,54.52l-8.5,16.67,8.83,8.96,10.5-14.48c22.04,24.01,39.9,51.86,52.56,82.39l-13.91,11.58,4.63,11.86,14.86-8.94c9.74,27.79,15.32,57.63,15.85,88.63l-16.46,5.58v12.64l16.27-2.81c-1.18,33.3-8.22,65.13-20.03,94.48l-16.67-1.27-4.92,11.67,15.6,3.7c-13.74,29.18-32.21,55.75-54.48,78.49l-14.43-7.38-9.07,8.92,12.55,9.09c-23.84,21.72-51.63,39.54-81.97,52.18l-10.08-12.11-11.86,4.61,7.82,12.87c-27.68,9.85-57.25,15.3-87.97,16.04l-5.01-14.75h-12.68l2.49,14.62c-33.13-1.04-64.85-7.76-94.14-19.38l1.18-15.66-11.62-4.9-3.42,14.73c-29.35-13.44-55.87-31.68-78.67-53.72l7.27-14.35-8.9-9.02-8.98,12.53c-22.1-23.65-40.11-51.06-52.96-81.27l12.85-10.8-4.61-11.77-13.88,8.33c-10.04-27.6-15.76-57.16-16.69-88.08l16.33-5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M3378.4,948.49c0,137.44,111.37,248.73,248.71,248.73s248.73-111.28,248.73-248.73-111.39-248.62-248.73-248.62-248.71,111.37-248.71,248.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M3397.42,894.12c-12.51,34.74-13.54,70.39-13.36,106.63-3.61-16.88-5.66-34.21-5.66-52.26,0-137.25,111.37-248.62,248.71-248.62s248.73,111.37,248.73,248.62c0,29.78-5.3,58.18-14.83,84.55.46-1.88.97-3.72,1.48-5.73,5.92-26.88,6.49-53.49,3.06-80.77-.06-.78-.13-1.48-.32-2.22-7.38-125.12-111.13-224.32-238.12-224.32-109.42,0-201.58,73.65-229.69,174.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M3614.89,1196.94c4.01.19,8.01.27,12.21.27-4.21,0-8.2-.08-12.21-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M3627.1,1197.21c4.14,0,8.22-.08,12.24-.27-4.01.19-8.09.27-12.24.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M3465.93,946.35c0,89.03,72.19,161.18,161.17,161.18s161.18-72.15,161.18-161.18-72.17-161.15-161.18-161.15-161.17,72.15-161.17,161.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3486.68,948.49c0,77.58,62.87,140.42,140.42,140.42s140.34-62.85,140.34-140.42-62.76-140.34-140.34-140.34-140.42,62.89-140.42,140.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M3494.56,949c0,73.2,59.28,132.58,132.54,132.58s132.54-59.38,132.54-132.58-59.28-132.6-132.54-132.6-132.54,59.4-132.54,132.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3514.2,951.21c0,62.38,50.57,112.93,112.91,112.93s112.93-50.55,112.93-112.93-50.57-112.89-112.93-112.89-112.91,50.53-112.91,112.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3553.16,948.4c0,40.89,33.07,74,73.94,74s73.94-33.11,73.94-74-33.07-73.92-73.94-73.92-73.94,33.07-73.94,73.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3619.83,853.82c0,3.95,3.25,7.14,7.12,7.14s7.1-3.19,7.1-7.14-3.28-6.99-7.1-6.99-7.12,3.15-7.12,6.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3620.19,1043.29c0,3.83,3.25,7.02,7.08,7.02s7.12-3.19,7.12-7.02-3.25-7.16-7.12-7.16-7.08,3.19-7.08,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3532.43,955.8c3.93,0,7.04-3.17,7.04-7.12s-3.11-7.08-7.04-7.08-7.06,3.19-7.06,7.08,3.11,7.12,7.06,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3721.8,955.48c3.93,0,7-3.25,7-7.08s-3.06-7.12-7-7.12-7.04,3.17-7.04,7.12,3.06,7.08,7.04,7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3555.09,886.7c2.68,2.77,7.19,2.77,9.91,0,2.71-2.73,2.71-7.27,0-10.02-2.73-2.77-7.23-2.77-9.91,0-2.77,2.75-2.77,7.29,0,10.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3689.21,1020.4c2.75,2.71,7.21,2.71,9.93,0,2.79-2.75,2.79-7.29,0-10.04-2.73-2.75-7.19-2.75-9.93,0-2.75,2.75-2.75,7.29,0,10.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3565.27,1020.55c2.79-2.75,2.79-7.23,0-9.95-2.75-2.73-7.21-2.73-9.93,0-2.87,2.73-2.87,7.21,0,9.95,2.73,2.83,7.18,2.83,9.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M3698.89,886.49c2.87-2.73,2.87-7.21,0-9.95-2.75-2.77-7.18-2.77-10,0-2.75,2.75-2.75,7.23,0,9.95,2.81,2.75,7.25,2.75,10,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3928.98,955.38c0-166.59-135.54-302.04-302.02-302.04s-302.02,135.46-302.02,302.04c0,.99.06,2.11.19,3.13h-31.36v-3.13c0-183.81,149.38-333.31,333.19-333.31s333.17,149.5,333.17,333.31v5.09h-31.34c0-1.69.19-3.4.19-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3623.09,635.11c-130.75,0-244.2,74.78-300.06,183.86,52.18-115.91,168.8-196.9,303.92-196.9,183.77,0,333.17,149.5,333.17,333.31v5.09h-.25c-6.17-180.51-154.84-325.36-336.78-325.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2058.61,836.83c0,213.65,173.2,386.91,386.89,386.91s386.91-173.26,386.91-386.91-173.28-387.07-386.91-387.07-386.89,173.41-386.89,387.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2068.35,840.76v-18.05l-23.41,3.93c1.12-47.34,10.46-92.62,26.69-134.55l25.68,1.92,6.93-16.57-24.18-5.66c18.98-41.94,45.03-79.93,76.46-112.68l23.52,11.93,12.79-12.57-20.6-14.96c33.75-31.57,73.1-57.41,116.4-75.77l17.41,20.93,16.67-6.65-13.4-22.33c39.5-14.39,81.87-22.47,125.97-23.61l8.67,25.76h17.98l-4.35-25.64c47.53,1.32,92.96,11.06,134.95,27.64l-2.03,27.01,16.53,7.03,6.11-25.38c41.91,19.34,79.9,45.62,112.42,77.5l-12,23.72,12.62,12.73,14.88-20.58c31.19,34.14,56.76,73.73,74.79,117.16l-19.86,16.48,6.64,16.84,21.05-12.7c13.86,39.52,21.7,81.93,22.44,126.01l-23.44,7.92v17.98l23.27-3.99c-1.69,47.36-11.56,92.6-28.34,134.34l-23.88-1.82-6.93,16.59,22.04,5.26c-19.38,41.5-45.6,79.27-77.51,111.6l-20.46-10.5-12.83,12.7,17.84,12.91c-34,30.9-73.27,56.21-116.31,74.2l-14.54-17.22-16.82,6.57,11.12,18.28c-39.24,14.01-81.4,21.75-125.25,22.8l-6.95-20.96h-18.03l3.53,20.77c-47.12-1.46-92.12-11.01-133.77-27.54l1.71-22.27-16.72-6.95-4.88,20.92c-41.52-19.1-79.27-45.01-111.87-76.37l10.4-20.39-12.64-12.85-12.91,17.84c-31.19-33.62-56.91-72.59-75.29-115.59l18.38-15.32-6.68-16.74-19.63,11.81c-14.29-39.24-22.53-81.27-23.75-125.25l23.41-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2091.95,836.57c0,195.43,158.15,353.65,353.54,353.65s353.54-158.22,353.54-353.65-158.24-353.5-353.54-353.5-353.54,158.34-353.54,353.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M2118.75,759.25c-17.54,49.41-19.12,100.1-19,151.62-5.11-23.99-7.8-48.65-7.8-74.3,0-195.16,158.15-353.5,353.54-353.5s353.54,158.34,353.54,353.5c0,42.35-7.31,82.71-20.96,120.22.72-2.68,1.48-5.28,1.96-8.16,8.52-38.23,9.26-76.03,4.52-114.81-.11-1.14-.42-2.13-.42-3.19-10.59-177.89-158.13-318.94-338.64-318.94-155.7,0-286.49,104.71-326.75,247.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2427.96,1189.84c5.9.27,11.69.38,17.54.38-5.85,0-11.64-.11-17.54-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2445.5,1190.22c5.85,0,11.64-.11,17.41-.38-5.77.27-11.56.38-17.41.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M2216.25,833.55c0,126.58,102.66,229.16,229.24,229.16s229.16-102.58,229.16-229.16-102.7-229.16-229.16-229.16-229.24,102.6-229.24,229.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2245.9,836.57c0,110.29,89.5,199.66,199.59,199.66s199.53-89.37,199.53-199.66-89.43-199.54-199.53-199.54-199.59,89.4-199.59,199.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M2256.91,837.29c0,104.1,84.55,188.52,188.58,188.52s188.58-84.42,188.58-188.52-84.55-188.56-188.58-188.56-188.58,84.47-188.58,188.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2284.91,840.46c0,88.69,71.87,160.56,160.58,160.56s160.58-71.87,160.58-160.56-71.87-160.52-160.58-160.52-160.58,71.83-160.58,160.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2340.21,836.47c0,58.13,47.17,105.22,105.28,105.22s105.3-47.08,105.3-105.22-47.17-105.13-105.3-105.13-105.28,47.04-105.28,105.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2435.27,701.96c0,5.62,4.37,10.16,9.97,10.16s10.02-4.54,10.02-10.16-4.42-9.93-10.02-9.93-9.97,4.46-9.97,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2435.75,971.37c0,5.43,4.35,9.97,9.95,9.97s10.02-4.54,10.02-9.97-4.52-10.21-10.02-10.21-9.95,4.54-9.95,10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2310.88,846.97c5.52,0,9.97-4.5,9.97-10.14s-4.46-10.04-9.97-10.04-10.1,4.52-10.1,10.04,4.63,10.14,10.1,10.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2580.13,846.5c5.47,0,10-4.61,10-10.04s-4.52-10.12-10-10.12-10.14,4.48-10.14,10.12,4.61,10.04,10.14,10.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2343.05,748.73c3.89,3.91,10.23,3.91,14.22,0,3.91-3.91,3.91-10.36,0-14.24-3.99-3.93-10.33-3.93-14.22,0-3.91,3.89-3.91,10.33,0,14.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2533.72,938.81c3.87,3.87,10.25,3.87,14.14,0,3.99-3.89,3.99-10.33,0-14.26-3.89-3.89-10.27-3.89-14.14,0-3.89,3.93-3.89,10.38,0,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2357.59,939.04c3.85-3.93,3.85-10.27,0-14.16-3.97-3.89-10.27-3.89-14.16,0-3.93,3.89-3.93,10.23,0,14.16,3.89,4.01,10.19,4.01,14.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M2547.59,748.41c3.91-3.89,3.91-10.23,0-14.16-3.91-3.93-10.19-3.93-14.16,0-3.87,3.93-3.87,10.27,0,14.16,3.97,3.89,10.25,3.89,14.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2865.79,856.44c.25-3.55.36-7.06.36-10.61,0-236.83-192.56-429.39-429.47-429.39-180.74,0-335.73,112.25-398.81,270.94-13.18-7.38-26.25-14.88-38.97-22.78,71.38-171.71,240.72-292.62,437.77-292.62,261.32,0,473.93,212.62,473.93,473.85,0,3.55-.23,7.06-.23,10.61h-44.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2429.44,390.98c-185.92,0-347.22,106.34-426.63,261.43,74.16-164.8,239.99-279.96,432.1-279.96,261.32,0,473.87,212.57,473.87,473.91,0,2.41-.11,4.84-.11,7.25h-.25c-8.9-256.65-220.26-462.63-478.98-462.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1990.4,
    y: 867.3,
    width: 101.55,
    height: 89.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "790.42 1062.05 255.41 1062.05 255.41 898.53 789.24 898.53 790.42 1062.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 19.93,
    y: 839.13,
    width: 2004.2,
    height: 141.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 19.93,
    y: 839.13,
    width: 2004.2,
    height: 51.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1164.35,839.13c4.78,25.68,11.12,57.42,14.81,70.31,6.88,23.1,12.19,25.3,36.63,25.3h55.23l-.13,45.24h-73.74c-20.28,0-38.94.34-49.54-31.53-7.03-21.45-23.54-75.82-33.72-109.32h50.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1158.74,839.13c4.93,25.78,12.7,64.69,16.88,78.25,6.55,21.07,11.6,23.1,34.51,23.1h52.09l3.57,31.49h-69.6c-19.09,0-34.99.55-45.05-28.49-7.04-20.52-22.66-74.6-31.32-104.35h38.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "1613.29 839.13 1568.58 1007.34 1555.18 1020.76 1284.32 1020.76 1269.32 1004 1251.51 839.13 1613.29 839.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1613.29 839.13 1601.82 882.3 1256.22 882.3 1251.51 839.13 1613.29 839.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1554.73,867.3c0,13.04,10.6,23.46,23.52,23.46s23.38-10.42,23.38-23.46-10.42-23.41-23.38-23.41-23.52,10.48-23.52,23.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1506.13,866.79c0,13,10.49,23.5,23.52,23.5s23.5-10.5,23.5-23.5-10.59-23.41-23.5-23.41-23.52,10.48-23.52,23.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1510.1,866.58c0,10.8,8.78,19.57,19.55,19.57s19.58-8.77,19.58-19.57-8.83-19.5-19.58-19.5-19.55,8.77-19.55,19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1558.76,866.96c0,10.95,8.78,19.55,19.49,19.55s19.55-8.6,19.55-19.55-8.71-19.55-19.55-19.55-19.49,8.83-19.49,19.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "1587.14 907.17 1564.33 1003.58 1552.52 1018.18 1292.7 1018.18 1273.19 1003.09 1256.08 842.51 1280.52 993.37 1303.26 1013.68 1544.02 1013.68 1559.07 999.86 1587.14 907.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1540.87,
    y: 839.13,
    width: 15.92,
    height: 211.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1099.5,
    y: 839.13,
    width: 15.92,
    height: 211.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1046.74,
    y: 941.6,
    width: 562.73,
    height: 35.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1046.74,
    y: 959.54,
    width: 562.73,
    height: 17.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600.97,941.6h8.51v35.8h-40.89c10.66-12.02,21.29-24.07,32.39-35.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1413.83,941.6h94.42c-10.77,12.36-21.88,24.22-33.41,35.8h-98.97c12.78-11.77,25.45-23.67,37.96-35.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1077.43,958.95c-6.87,6.06-13.71,12.32-20.49,18.45h-10.2v-35.8h49.89c-6.37,5.83-12.87,11.66-19.21,17.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1204.11,941.6h99.7c-13.45,12.02-26.93,23.96-40.65,35.8h-100.73c13.54-12.38,27.26-24.37,41.67-35.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1046.74,
    y: 1023.55,
    width: 562.73,
    height: 35.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1046.74,
    y: 1041.39,
    width: 562.73,
    height: 17.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600.97,1023.55h8.51v35.71h-40.89c10.66-12.05,21.29-24.11,32.39-35.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1413.83,1023.55h94.42c-10.77,12.26-21.88,24.09-33.41,35.71h-98.97c12.78-11.75,25.45-23.65,37.96-35.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1077.43,1040.77c-6.87,6.09-13.71,12.32-20.49,18.49h-10.2v-35.71h49.89c-6.37,5.81-12.87,11.52-19.21,17.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1204.11,1023.55h99.7c-13.45,11.98-26.93,23.96-40.65,35.71h-100.73c13.54-12.4,27.26-24.34,41.67-35.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M77.61,1058.95c0,101.01,81.87,183.13,183.02,183.13s183.16-82.12,183.16-183.13-82.07-183.07-183.16-183.07-183.02,81.99-183.02,183.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M259.44,896.86c-90.97,0-165.78,68.43-176.25,156.51,1.72-96.57,80.5-174.21,177.44-174.21s177.5,79.37,177.5,177.43c0,6.93-.52,13.91-1.3,20.82,0-1.06.08-2.09.08-3.04,0-98.12-79.46-177.49-177.47-177.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M259.44,1220c-90.97,0-165.78-68.3-176.25-156.48,1.72,96.6,80.5,174.32,177.44,174.32s177.5-79.44,177.5-177.4c0-7.06-.52-13.97-1.3-20.86,0,.95.08,2.13.08,2.98,0,98.07-79.46,177.45-177.47,177.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M260.62,921.08c76.34,0,138.08,61.9,138.08,138.18s-61.74,138.1-138.08,138.1-138.12-61.83-138.12-138.1,61.97-138.18,138.12-138.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M145.22,1058.57c0,64.6,52.44,117.07,116.96,117.07s117.08-52.47,117.08-117.07-52.37-117.07-117.08-117.07-116.96,52.41-116.96,117.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.98,1058.57c0,56.53,45.76,102.15,102.2,102.15s102.21-45.62,102.21-102.15-45.68-102.2-102.21-102.2-102.2,45.67-102.2,102.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M167.7,1058.57c0,52.2,42.32,94.52,94.48,94.52s94.66-42.33,94.66-94.52-42.42-94.52-94.66-94.52-94.48,42.35-94.48,94.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M228.51,1058.14c0,17.77,14.31,32.14,32.11,32.14s32.07-14.37,32.07-32.14-14.37-32.23-32.07-32.23-32.11,14.35-32.11,32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M242.47,1058.14c0,9.95,8.17,18.09,18.15,18.09s18.13-8.14,18.13-18.09-8.2-18.15-18.13-18.15-18.15,8.16-18.15,18.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M376.74,1050.03c.11,1.56.11,2.9.11,4.33,0,63.4-51.36,114.68-114.71,114.68s-114.64-51.29-114.64-114.68c0-1.63.14-2.98.14-4.44,96.13,30.03,176.1,17.67,229.11.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M260.62,978.5c2.91,0,5.19-2.37,5.19-5.18s-2.28-5.18-5.19-5.18-5.21,2.24-5.21,5.18,2.26,5.18,5.21,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M260.62,1145.74c2.91,0,5.19-2.39,5.19-5.22s-2.28-5.18-5.19-5.18-5.21,2.39-5.21,5.18,2.26,5.22,5.21,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M182.21,1056.9c0-2.81-2.32-5.2-5.23-5.2s-5.18,2.39-5.18,5.2,2.27,5.16,5.18,5.16,5.23-2.37,5.23-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M349.4,1056.9c0-2.81-2.25-5.2-5.16-5.2s-5.24,2.39-5.24,5.2,2.42,5.16,5.24,5.16,5.16-2.37,5.16-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M205.07,1001.42c2.1-2.01,2.1-5.24,0-7.31-1.95-1.97-5.28-1.97-7.22,0-2.02,2.07-2.07,5.3,0,7.31,1.93,2.05,5.26,2.05,7.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M323.35,1119.64c2.04-1.99,2.04-5.2,0-7.29-1.91-1.92-5.24-1.92-7.2,0-2.12,2.09-2.12,5.41,0,7.29,1.95,2.05,5.28,2.05,7.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M205.07,1112.35c-1.95-1.92-5.28-1.92-7.22,0-2.02,2.09-2.02,5.3,0,7.29,1.93,2.05,5.26,2.05,7.22,0,2.1-1.99,2.1-5.2,0-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M323.35,994.11c-1.91-1.97-5.24-1.97-7.2,0-2.12,2.07-2.12,5.3,0,7.31,1.95,2.05,5.28,1.97,7.2,0,2.04-2.01,2.04-5.24,0-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M607.34,1058.95c0,101.01,81.95,183.13,183.08,183.13s183.05-82.12,183.05-183.13-81.81-183.07-183.05-183.07-183.08,81.99-183.08,183.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M789.24,896.86c-91.01,0-165.78,68.43-176.32,156.51,1.81-96.57,80.57-174.21,177.5-174.21s177.44,79.37,177.44,177.43c0,6.93-.35,13.91-1.24,20.82,0-1.06.08-2.09.08-3.04,0-98.12-79.46-177.49-177.47-177.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M789.24,1220c-91.01,0-165.78-68.3-176.32-156.48,1.81,96.6,80.57,174.32,177.5,174.32s177.44-79.44,177.44-177.4c0-7.06-.35-13.97-1.24-20.86,0,.95.08,2.13.08,2.98,0,98.07-79.46,177.45-177.47,177.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M790.42,921.08c76.22,0,138.07,61.9,138.07,138.18s-61.84,138.1-138.07,138.1-138.18-61.83-138.18-138.1,61.92-138.18,138.18-138.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M674.93,1058.57c0,64.6,52.44,117.07,117.04,117.07s117.05-52.47,117.05-117.07-52.33-117.07-117.05-117.07-117.04,52.41-117.04,117.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M689.9,1058.57c0,56.53,45.57,102.15,102.07,102.15s102.23-45.62,102.23-102.15-45.68-102.2-102.23-102.2-102.07,45.67-102.07,102.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M697.48,1058.57c0,52.2,42.3,94.52,94.49,94.52s94.58-42.33,94.58-94.52-42.37-94.52-94.58-94.52-94.49,42.35-94.49,94.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M758.19,1058.14c0,17.77,14.42,32.14,32.23,32.14s32.22-14.37,32.22-32.14-14.69-32.23-32.22-32.23-32.23,14.35-32.23,32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M772.24,1058.14c0,9.95,8.14,18.09,18.18,18.09s18.1-8.14,18.1-18.09-8.06-18.15-18.1-18.15-18.18,8.16-18.18,18.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M906.57,1050.03v4.33c0,63.4-51.17,114.68-114.6,114.68s-114.6-51.29-114.6-114.68c0-1.63.11-2.98.11-4.44,96.2,30.03,176.01,17.67,229.09.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M790.42,978.5c2.81,0,5.12-2.37,5.12-5.18s-2.31-5.18-5.12-5.18c-2.96,0-5.19,2.24-5.19,5.18s2.23,5.18,5.19,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M790.42,1145.74c2.81,0,5.12-2.39,5.12-5.22s-2.31-5.18-5.12-5.18c-2.96,0-5.19,2.39-5.19,5.18s2.23,5.22,5.19,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M711.96,1056.9c0-2.81-2.33-5.2-5.16-5.2s-5.21,2.39-5.21,5.2,2.25,5.16,5.21,5.16,5.16-2.37,5.16-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M879.11,1056.9c0-2.81-2.28-5.2-5.14-5.2s-5.12,2.39-5.12,5.2,2.34,5.16,5.12,5.16,5.14-2.37,5.14-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M734.97,1001.42c1.9-2.01,1.9-5.24,0-7.31-2.12-1.97-5.45-1.97-7.44,0-1.93,2.07-1.93,5.3,0,7.31,1.99,2.05,5.31,2.05,7.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M853.22,1119.64c1.99-1.99,1.99-5.2,0-7.29-2.07-1.92-5.35-1.92-7.33,0-2.04,2.09-2.04,5.41,0,7.29,1.99,2.05,5.26,2.05,7.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M734.97,1112.35c-2.12-1.92-5.45-1.92-7.44,0-1.93,2.09-1.93,5.3,0,7.29,1.99,2.05,5.31,2.05,7.44,0,1.9-1.99,1.9-5.2,0-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M853.22,994.11c-2.07-1.97-5.35-1.97-7.33,0-2.04,2.07-2.04,5.3,0,7.31,1.99,2.05,5.26,1.97,7.33,0,1.99-2.01,1.99-5.24,0-7.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "986.03 938.15 906.57 846.88 95.89 846.88 0 1013.91 41.14 1013.91 122.5 872.86 886.55 872.86 959.72 956.37 986.03 938.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "986.03 938.15 906.57 846.88 95.89 846.88 0 1013.91 19.93 1013.91 107.54 862.4 894.2 859.82 974.09 942.11 986.03 938.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1624.24,1058.95c0,101.01,81.88,183.13,183.08,183.13s183.08-82.12,183.08-183.13-81.95-183.07-183.08-183.07-183.08,81.99-183.08,183.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1806.14,896.86c-91.06,0-165.81,68.43-176.23,156.51,1.69-96.57,80.48-174.21,177.42-174.21s177.42,79.37,177.42,177.43c0,6.93-.36,13.91-1.24,20.82,0-1.06.05-2.09.05-3.04,0-98.12-79.4-177.49-177.42-177.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1806.14,1220c-91.06,0-165.81-68.3-176.23-156.48,1.69,96.6,80.48,174.32,177.42,174.32s177.42-79.44,177.42-177.4c0-7.06-.36-13.97-1.24-20.86,0,.95.05,2.13.05,2.98,0,98.07-79.4,177.45-177.42,177.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1807.32,921.08c76.17,0,138.05,61.9,138.05,138.18s-61.88,138.1-138.05,138.1-138.2-61.83-138.2-138.1,61.94-138.18,138.2-138.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1691.78,1058.57c0,64.6,52.49,117.07,117.09,117.07s117.05-52.47,117.05-117.07-52.37-117.07-117.05-117.07-117.09,52.41-117.09,117.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1706.79,1058.57c0,56.53,45.62,102.15,102.09,102.15s102.14-45.62,102.14-102.15-45.65-102.2-102.14-102.2-102.09,45.67-102.09,102.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1714.36,1058.57c0,52.2,42.32,94.52,94.51,94.52s94.49-42.33,94.49-94.52-42.34-94.52-94.49-94.52-94.51,42.35-94.51,94.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1775.08,1058.14c0,17.77,14.41,32.14,32.25,32.14s32.09-14.37,32.09-32.14-14.45-32.23-32.09-32.23-32.25,14.35-32.25,32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1789.17,1058.14c0,9.95,8.08,18.09,18.15,18.09s18.07-8.14,18.07-18.09-8.14-18.15-18.07-18.15-18.15,8.16-18.15,18.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1923.49,1050.03v4.33c0,63.4-51.27,114.68-114.61,114.68s-114.6-51.29-114.6-114.68v-4.44c96.29,30.03,176.15,17.67,229.21.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1807.32,978.5c2.79,0,5.02-2.37,5.02-5.18s-2.23-5.18-5.02-5.18-5.24,2.24-5.24,5.18,2.42,5.18,5.24,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1807.32,1145.74c2.79,0,5.02-2.39,5.02-5.22s-2.23-5.18-5.02-5.18-5.24,2.39-5.24,5.18,2.42,5.22,5.24,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1728.72,1056.9c0-2.81-2.3-5.2-5.09-5.2s-5.19,2.39-5.19,5.2,2.34,5.16,5.19,5.16,5.09-2.37,5.09-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1896.02,1056.9c0-2.81-2.28-5.2-5.14-5.2s-5.21,2.39-5.21,5.2,2.42,5.16,5.21,5.16,5.14-2.37,5.14-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1751.82,1001.42c1.93-2.01,1.93-5.24,0-7.31-2.12-1.97-5.29-1.97-7.35,0-2,2.07-2,5.3,0,7.31,2.06,2.05,5.23,2.05,7.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1870.02,1119.64c2.01-1.99,2.01-5.2,0-7.29-2.02-1.92-5.26-1.92-7.25,0-2.09,2.09-1.99,5.41,0,7.29,1.99,2.05,5.23,2.05,7.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1751.82,1112.35c-2.12-1.92-5.29-1.92-7.35,0-2,2.09-2,5.3,0,7.29,2.06,2.05,5.23,2.05,7.35,0,1.93-1.99,1.93-5.2,0-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1870.02,994.11c-2.02-1.97-5.26-1.97-7.25,0-1.99,2.07-2.09,5.3,0,7.31,1.99,2.05,5.23,1.97,7.25,0,2.01-2.01,2.01-5.24,0-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2009.79,990.71c1.31,0,2.9-.23,4.43-.78,6.41-2.58,9.58-9.74,7.14-16.27-.68-1.5-62.19-154.5-209.26-150.61-142.98,3.57-181.6,69.86-214.25,149.64-2.5,6.4.45,13.74,6.9,16.29,6.41,2.62,13.73-.46,16.25-6.8,30.31-73.98,63.71-130.89,191.72-134.13,53.89-1.33,101.5,20.6,140.99,65.24,30.13,34.06,44.18,69.19,44.25,69.5,1.99,4.94,6.69,7.92,11.82,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2014.22,989.93c6.41-2.58,9.58-9.74,7.14-16.27-.68-1.5-62.19-154.5-209.26-150.61-142.98,3.57-181.6,69.86-214.25,149.64-2.5,6.4.45,13.74,6.9,16.29,6.41,2.62,25.16-153.44,204.77-150.88,54.04.72,112.54,22.84,152.14,67.5,30.1,34.02,51.02,84.89,52.56,84.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 93.16,
    y: 524.14,
    width: 24.22,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 93.16,
    y: 524.14,
    width: 24.22,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 93.16,
    y: 794.69,
    width: 24.22,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 111,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M105.74,750.52c0,6.42-1.9,11.69-4.29,11.69h0c-2.36,0-4.28-5.26-4.28-11.69v-140.98c0-6.32,1.92-11.65,4.28-11.65h0c2.39,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 676.4,
    y: 524.14,
    width: 24.25,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 676.4,
    y: 524.14,
    width: 24.25,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 676.4,
    y: 794.69,
    width: 24.25,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 694.27,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M689,750.52c0,6.42-1.93,11.69-4.3,11.69h0c-2.35,0-4.28-5.26-4.28-11.69v-140.98c0-6.32,1.93-11.65,4.28-11.65h0c2.37,0,4.3,5.34,4.3,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 593.12,
    y: 524.14,
    width: 24.2,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 593.12,
    y: 524.14,
    width: 24.2,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 593.12,
    y: 794.69,
    width: 24.2,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 610.92,
    y: 524.14,
    width: 6.39,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M605.68,750.52c0,6.42-1.92,11.69-4.3,11.69h0c-2.35,0-4.26-5.26-4.26-11.69v-140.98c0-6.32,1.91-11.65,4.26-11.65h0c2.38,0,4.3,5.34,4.3,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 509.77,
    y: 524.14,
    width: 24.22,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 509.77,
    y: 524.14,
    width: 24.22,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 509.77,
    y: 794.69,
    width: 24.22,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 527.61,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M522.36,750.52c0,6.42-1.91,11.69-4.29,11.69h0c-2.36,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.93-11.65,4.29-11.65h0c2.38,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 426.45,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 426.45,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 426.45,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 444.29,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M439.04,750.52c0,6.42-1.94,11.69-4.32,11.69h0c-2.35,0-4.27-5.26-4.27-11.69v-140.98c0-6.32,1.92-11.65,4.27-11.65h0c2.38,0,4.32,5.34,4.32,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 343.13,
    y: 524.14,
    width: 24.2,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 343.13,
    y: 524.14,
    width: 24.2,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 343.13,
    y: 794.69,
    width: 24.2,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 360.98,
    y: 524.14,
    width: 6.35,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M355.7,750.52c0,6.42-1.91,11.69-4.27,11.69h0c-2.38,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.91-11.65,4.29-11.65h0c2.36,0,4.27,5.34,4.27,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 259.82,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 259.82,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 259.82,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 277.67,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M272.38,750.52c0,6.42-1.91,11.69-4.3,11.69h0c-2.35,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.94-11.65,4.29-11.65h0c2.39,0,4.3,5.34,4.3,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 176.48,
    y: 524.14,
    width: 24.22,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 176.48,
    y: 524.14,
    width: 24.22,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 176.48,
    y: 794.69,
    width: 24.22,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 194.32,
    y: 524.14,
    width: 6.37,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M189.06,750.52c0,6.42-1.93,11.69-4.29,11.69h0c-2.38,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.91-11.65,4.29-11.65h0c2.36,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 755.38,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 755.38,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 755.38,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 773.23,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M767.96,750.52c0,6.42-1.89,11.69-4.29,11.69h0c-2.35,0-4.28-5.26-4.28-11.69v-140.98c0-6.32,1.93-11.65,4.28-11.65h0c2.4,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1338.63,
    y: 524.14,
    width: 24.25,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1338.63,
    y: 524.14,
    width: 24.25,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1338.63,
    y: 794.69,
    width: 24.25,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1356.5,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1351.22,750.52c0,6.42-1.92,11.69-4.29,11.69h0c-2.36,0-4.28-5.26-4.28-11.69v-140.98c0-6.32,1.92-11.65,4.28-11.65h0c2.37,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1255.34,
    y: 524.14,
    width: 24.2,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1255.34,
    y: 524.14,
    width: 24.2,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1255.34,
    y: 794.69,
    width: 24.2,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1273.15,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1267.9,750.52c0,6.42-1.91,11.69-4.29,11.69h0c-2.36,0-4.27-5.26-4.27-11.69v-140.98c0-6.32,1.91-11.65,4.27-11.65h0c2.38,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1171.99,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1171.99,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1171.99,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1189.84,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1184.59,750.52c0,6.42-1.91,11.69-4.3,11.69h0c-2.35,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.94-11.65,4.29-11.65h0c2.39,0,4.3,5.34,4.3,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1088.68,
    y: 524.14,
    width: 24.22,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1088.68,
    y: 524.14,
    width: 24.22,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1088.68,
    y: 794.69,
    width: 24.22,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1106.52,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1101.26,750.52c0,6.42-1.93,11.69-4.32,11.69h0c-2.35,0-4.26-5.26-4.26-11.69v-140.98c0-6.32,1.91-11.65,4.26-11.65h0c2.39,0,4.32,5.34,4.32,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1005.37,
    y: 524.14,
    width: 24.19,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1005.37,
    y: 524.14,
    width: 24.19,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1005.37,
    y: 794.69,
    width: 24.19,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1023.2,
    y: 524.14,
    width: 6.35,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1017.92,750.52c0,6.42-1.91,11.69-4.26,11.69h0c-2.38,0-4.3-5.26-4.3-11.69v-140.98c0-6.32,1.92-11.65,4.3-11.65h0c2.35,0,4.26,5.34,4.26,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 922.04,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 922.04,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 922.04,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 939.89,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M934.6,750.52c0,6.42-1.91,11.69-4.29,11.69h0c-2.36,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.93-11.65,4.29-11.65h0c2.38,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 838.7,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 838.7,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 838.7,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 856.54,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M851.29,750.52c0,6.42-1.94,11.69-4.29,11.69h0c-2.39,0-4.3-5.26-4.3-11.69v-140.98c0-6.32,1.91-11.65,4.3-11.65h0c2.35,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1420.46,
    y: 524.14,
    width: 24.22,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1420.46,
    y: 524.14,
    width: 24.22,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1420.46,
    y: 794.69,
    width: 24.22,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1438.29,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1433.03,750.52c0,6.42-1.9,11.69-4.3,11.69h0c-2.35,0-4.28-5.26-4.28-11.69v-140.98c0-6.32,1.93-11.65,4.28-11.65h0c2.4,0,4.3,5.34,4.3,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2003.69,
    y: 524.14,
    width: 24.25,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2003.69,
    y: 524.14,
    width: 24.25,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2003.69,
    y: 794.69,
    width: 24.25,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2021.56,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M2016.28,750.52c0,6.42-1.92,11.69-4.29,11.69h0c-2.35,0-4.28-5.26-4.28-11.69v-140.98c0-6.32,1.93-11.65,4.28-11.65h0c2.37,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1920.4,
    y: 524.14,
    width: 24.2,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1920.4,
    y: 524.14,
    width: 24.2,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1920.4,
    y: 794.69,
    width: 24.2,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1938.22,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1932.97,750.52c0,6.42-1.91,11.69-4.29,11.69h0c-2.36,0-4.27-5.26-4.27-11.69v-140.98c0-6.32,1.91-11.65,4.27-11.65h0c2.38,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1837.06,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1837.06,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1837.06,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1854.9,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1849.65,750.52c0,6.42-1.91,11.69-4.29,11.69h0c-2.36,0-4.3-5.26-4.3-11.69v-140.98c0-6.32,1.94-11.65,4.3-11.65h0c2.38,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1753.74,
    y: 524.14,
    width: 24.23,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1753.74,
    y: 524.14,
    width: 24.23,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1753.74,
    y: 794.69,
    width: 24.23,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1771.59,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1766.34,750.52c0,6.42-1.94,11.69-4.32,11.69h0c-2.36,0-4.27-5.26-4.27-11.69v-140.98c0-6.32,1.91-11.65,4.27-11.65h0c2.38,0,4.32,5.34,4.32,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1670.43,
    y: 524.14,
    width: 24.2,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1670.43,
    y: 524.14,
    width: 24.2,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1670.43,
    y: 794.69,
    width: 24.2,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1688.28,
    y: 524.14,
    width: 6.35,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1682.99,750.52c0,6.42-1.91,11.69-4.27,11.69h0c-2.38,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.91-11.65,4.29-11.65h0c2.36,0,4.27,5.34,4.27,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1587.12,
    y: 524.14,
    width: 24.22,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1587.12,
    y: 524.14,
    width: 24.22,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1587.12,
    y: 794.69,
    width: 24.22,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1604.95,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1599.67,750.52c0,6.42-1.91,11.69-4.29,11.69h0c-2.35,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.94-11.65,4.29-11.65h0c2.38,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1503.77,
    y: 524.14,
    width: 24.22,
    height: 293.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1503.77,
    y: 524.14,
    width: 24.22,
    height: 45.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1503.77,
    y: 794.69,
    width: 24.22,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1521.61,
    y: 524.14,
    width: 6.38,
    height: 293.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1516.35,750.52c0,6.42-1.94,11.69-4.29,11.69h0c-2.38,0-4.29-5.26-4.29-11.69v-140.98c0-6.32,1.91-11.65,4.29-11.65h0c2.35,0,4.29,5.34,4.29,11.65v140.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 65.68,
    y: 805.63,
    width: 1959.07,
    height: 69.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 65.68,
    y: 831.67,
    width: 1959.07,
    height: 43.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 65.68,
    y: 479.67,
    width: 1962.27,
    height: 79.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 65.68,
    y: 524.14,
    width: 1962.27,
    height: 35.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 65.68,
    y: 476.05,
    width: 1962.27,
    height: 16.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1414.66,517.31c0,4.05-3.23,7.25-7.25,7.25s-7.25-3.2-7.25-7.25,3.26-7.22,7.25-7.22,7.25,3.26,7.25,7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M122.16,517.31c0,4.05-3.3,7.25-7.28,7.25s-7.25-3.2-7.25-7.25,3.25-7.22,7.25-7.22,7.28,3.26,7.28,7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1414.66,821.5c0,3.95-3.23,7.25-7.25,7.25s-7.25-3.3-7.25-7.25,3.26-7.21,7.25-7.21,7.25,3.25,7.25,7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M122.16,821.5c0,3.95-3.3,7.25-7.28,7.25s-7.25-3.3-7.25-7.25,3.25-7.21,7.25-7.21,7.28,3.25,7.28,7.21Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractorTrolley);
export default __webpack_public_path__ + "static/media/Tractor_Trolley.58bd95af585df2d1d35c7df4219e41de.svg";
export { ForwardRef as ReactComponent };